/**
 * GENERATED FILE — Portuguese gender and plural lexicon. DO NOT EDIT BY HAND.
 *
 * Emitted by data-pipeline/run-nouns.ts from the Wiktionary (wiktextract)
 * dump at kaikki.org. Data licence: CC BY-SA — see LICENSE-DATA.md.
 *
 * Only entries the rules get wrong are stored: gender where the ending
 * heuristic misleads (2800 of 35458 nouns), and plurals the
 * rules do not produce (1931 of 31869 attested).
 */
import type { GrammaticalGender } from "../core/features.js";

const GENDER_DATA = `🥄|f
a|m
abadessão|m
abádida|m
abalonas|f
abaneenga|m
abañeenga|m
abanheenga|m
abantesma|f
abássida|m
abdominocentese|f
abilasão|m
abiogénese|f
abiogênese|f
abiose|f
aboiz|f
abração|m
abside|f
abugida|m
abulasão|m
abuna|m
abzima|f
açafrão-da-índia|m
açafrão-da-terra|m
acantamebíase|f
acantocitose|f
acantólise|f
acantose|f
acará-bandeira|m
acareação|m
acaríase|f
acaricida|m
acarose|f
acetilase|f
acetilcolinesterase|f
acetilesterase|f
acetogénese|f
acetogênese|f
acetólise|f
achagua|m
acidólise|f
acidose|f
aciltransferase|f
acne|f
açoite|m
acondrogénese|f
acondrogênese|f
aconitase|f
acrescerão|f
acridão|f
acritarca|m
acroceratose|f
acrocianose|f
acrodermatose|f
acrofase|f
acrópole|f
acropustulose|f
actinobacilose|f
actinomicose|f
açude|m
adenoide|f
adenoipófise|f
adenomatose|f
adenomiomatose|f
adenomiose|f
adenose|f
adenosiltransferase|f
adhesaõ|f
adição-padrão|f
adimplência|m
adinkra|m
adipogénese|f
adipogênese|f
adipose|f
adjacências|f
adulticida|m
adustão|f
advaita|m
aerobiose|f
aeronauta|m
aeronave|f
afânise|f
afegã|f
aférese|f
afia|m
afiador|f
aficida|m
afidicida|m
aflatoxicose|f
aftose|f
agadá|f
agamogénese|f
agamogênese|f
aganglionose|f
agarose|f
agave|f
agnose|f
agonista|m
agora|m
agranulocitose|f
agrecanase|f
agrícola|m
agrónoma|f
agrônoma|f
água-de-cheiro|f
água-forte|f
água-má|f
água-mel|f
água-neve|f
água-pé|f
aguardente|f
aguarrás|f
aguaruna|m
águas-furtadas|f
águia-real|f
ahamkara|m
ahimsa|m
aí|f
aiê|f
aimara|m
alabarca|m
alaminuta|m
alantoicase|f
alantoinase|f
alazã|f
albuminose|f
albumose|f
alcalose|f
alçaprema|f
alcoólise|f
aldeã|f
alderney|f
aldoexose|f
aldolase|f
aldopentose|f
aldose|f
aldotetrose|f
aldotriose|f
aldoxima|f
aldracema|f
ale|f
alemã|f
alerta|m
alfa|m
alface|f
alface-de-cordeiro|f
alfarrabista|m
alfazema|f
alfinete-de-fralda|m
algema|f
algicida|m
alglucerase|f
algodão-da-praia|m
algodão-de-seda|m
algodoeiro-da-praia|m
aliá|f
aliinase|f
alinfocitose|f
aliyá|f
allucinaçaõ|f
alma|f
almoção|m
almude|m
aloenzima|f
alolactose|f
alomãe|f
alopoiese|f
alostase|f
alozima|f
alpha|m
alquiltransferase|f
alteplase|f
altrose|f
alude|m
alvacá|f
alveolar|f
alvíssaras|f
amahuaca|m
amanita|m
amapô|f
amarelo-banana|m
amarelo-mostarda|m
amarílis|f
amastigota|m
amatriciana|m
amaurose|f
ambarvais|f
amebíase|f
amebicida|m
amêijoa-gigante|f
amelanose|f
amelogénese|f
amelogênese|f
ameraba|m
ametade|f
amidinotransferase|f
amido-hidrolase|f
amidoidrolase|f
amidoxima|f
amigo-da-onça|m
amigue|n
amilase|f
amílase|f
amiloglucosidase|f
amiloidose|f
amilólise|f
amilose|f
aminólise|f
aminometiltransferase|f
aminopeptidase|f
aminopolipeptidase|f
amitose|f
amizade|f
amniocentese|f
amniorrexe|f
amniota|m
amonita|m
amonólise|f
amora-silvestre|f
amorfossíntese|f
amorita|m
ampere-espira|m
ampère-espira|m
ampere-hora|m
ampère-hora|m
amplidão|f
amrita|m
anã|f
anábase|f
anabiose|f
anaciclose|f
anacruse|f
anadiplose|f
anaerobicida|m
anaerobiose|f
anafase|f
anáfase|f
anagénese|f
anagênese|f
anagnórise|f
anagoge|f
analcima|f
analepse|f
análise|f
anamnese|f
anamorfose|f
ananke|f
anaplasmose|f
anaplerose|f
anapófise|f
anápsida|m
anaptixe|f
anastilose|f
anastomose|f
anástrofe|f
anatase|f
anátase|f
anatexe|f
anatéxis|f
anciã|f
ancilose|f
ancilostomíase|f
ancilostomose|f
andorinha-das-barreiras|f
andorinha-das-chaminés|f
andorinha-de-bando|f
andorinha-do-mar|f
andorinha-dos-beirais|f
androgénese|f
androgênese|f
anémona-do-mar|f
anêmona-do-mar|f
anémone|f
anêmone|f
anfiartrose|f
anfíbole|f
anfitriã|f
angioendoteliomatose|f
angiogénese|f
angiogênese|f
angiomatose|f
angioneurose|f
angiosperma|f
angiotensinase|f
anglo-frisão|m
anhima|f
anhuma|f
anidrase|f
anidrobiose|f
anidrose|f
anima|f
ánima|f
ânima|f
anisaquíase|f
anisocitose|f
anniversario|f
anoa|m
anónima|f
anortoclase|f
anoxibiose|f
anquilose|f
ansiólise|f
anspeçada|m
antanáclase|f
antanagoge|f
anteflexão|f
antélix|f
antemanhã|f
antese|f
anti-hélix|f
antiangiogénese|f
antiangiogênese|f
antiarte|f
antibiose|f
anticiclogênese|f
anticolinesterase|f
anticor|f
anticrese|f
anticristã|f
antidiagonal|f
antidiurese|f
antiêmese|f
antifase|f
antiforma|f
antífrase|f
antilambda|m
antilegomena|m
antimãe|f
antimesão|m
antimetábole|f
antipapa|m
antiperistalse|f
antiperístase|f
antipirese|f
antiplaneta|m
antipoeta|m
antiprotease|f
antiproteinase|f
antiptose|f
antístrofe|f
antítese|f
antitrombose|f
antivórtice|m
antracnose|f
antracose|f
antropogénese|f
antropogênese|f
antropomorfose|f
antroponose|f
antropozoonose|f
anurese|f
anusvara|m
apagoge|f
aparigraha|m
apelaçam|f
apelaçaõ|f
apellaçam|f
apellaçaõ|f
apêndice|m
apetite|m
apical|f
ápice|m
apiose|f
apirase|f
apneuse|f
apocatástase|f
apócope|f
apodioxe|f
apodixe|f
apódose|f
apoenzima|f
apófase|f
apófise|f
apólise|f
apomeiose|f
aponeurose|f
apoptose|f
aposiopese|f
apóstrofe|f
aposturas|f
apoteose|f
appelaçam|f
appelaçaõ|f
appellaçam|f
appellaçaõ|f
aproximante|f
apsará|f
apside|f
aptidão|f
aq|f
aquamação|m
aquanauta|m
aqueménida|m
aquemênida|m
aquiclude|m
aqüiclude|m
arabá|f
arabela|m
arábica|m
arabinase|f
arabinofuranose|f
arabinofuranosidase|f
arabinopiranose|f
arabinose|f
arabinosiltransferase|f
aracnoide|f
aracnóide|f
aranha-lobo|f
aranha-marrom|f
arara-canindé|f
arara-macau|f
araribá|f
arboricida|m
arbovirose|f
arbusto-da-independência|m
arcado-cipriota|m
archine|f
arco-da-velha|m
arco-e-flecha|m
arcose|f
areopagita|m
areté|f
aretê|f
arginase|f
argininosuccinase|f
argirose|f
argolas|f
argonauta|m
aribé|f
arilamidase|f
arilesterase|f
arilsulfatase|f
aritenoide|f
aritenóide|f
arma|f
aromatase|f
arqué|f
arquidiocese|f
arquidruida|m
arquimandrita|m
arquitrave|f
arrã|f
arras|f
arrebite|m
arriboflavinose|f
arritmogénese|f
arritmogênese|f
arrocha|m
arroubo|f
arroz-agulha|m
arroz-de-leite|m
arse|f
ársis|f
arte|f
arterioesclerose|f
arteriogénese|f
arteriogênese|f
arterioloesclerose|f
arteriolosclerose|f
arteriosclerose|f
artesã|f
artesão|m
artrocentese|f
artrodese|f
artródese|f
artrofibrose|f
artrogripose|f
artrose|f
árvore|f
ascaríase|f
ascaridíase|f
ascese|f
asiarca|m
asma|f
aspas|f
áspide|f
assignatura|m
assuã|f
astro-rei|f
astronave|f
astrónoma|f
astrônoma|f
atenuante|f
atrabile|f
atrabílis|f
audiência-alvo|f
autárquicas|f
auto-estima|f
autoestima|f
autoginefilia|m
autognose|f
autopoiese|f
autuação|m
avalanche|f
avanheenga|m
avantesma|f
ave|f
ave-do-paraíso|f
avelã|f
avellã|f
aventesma|f
avionete|f
avó|f
axadrez|m
ayurveda|m
azáfama|f
azeite|m
bá|f
babá|f
bacante|f
bag|f
baga-de-freira|m
baguete|f
baite|m
baitola|m
baixa-mar|f
baleia-anã|f
baleia-azul|f
baleia-boreal|f
baleia-comum|f
baleia-fin|f
baleia-jubarte|f
baleia-piloto|f
baleia-sei|f
bambara|m
banana-pão|f
bandelete|f
bandolete|f
banho-maria|m
banshee|f
banya|m
barba-de-velho|f
barbacã|f
barbárie|f
bariogénese|f
bariogênese|f
barregã|f
barriga-branca|m
base|f
batata-doce|f
batateiro|f
bate-boca|m
beija-flor-de-barriga-branca|m
beija-flor-de-fronte-violeta|m
beija-flor-de-orelha-violeta|m
beirã|f
belas-artes|f
belas-letras|f
benesse|f
bérberis|f
beriliose|f
berma|f
bernardo-eremita|m
besouro-da-batata|m
bet|f
beta|m
betta|m
bexigas|f
bi|f
bicampeã|f
bicha-alfinete|f
bicha-do-milho|f
bicha-galo|f
bicho-da-farinha|m
bicho-da-seda|m
bicho-de-conta|m
bicho-preguiça|m
bici|f
biciclete|f
bienal|f
bígama|f
biguatinga|m
bike|f
bilabial|f
bile|f
bílis|f
biogénese|f
biogênese|f
biossíntese|f
biriba|m
bisão|m
bisavó|f
bitaite|m
blasfema|f
blitz|f
blitzkrieg|f
blusão|m
boá|f
boa-fé|f
boa-noite|m
boa-noite-cinderela|m
boas-festas|f
boas-vindas|f
boate|f
bobine|f
boca-a-boca|m
boca-de-fumo|f
boca-de-incêndio|f
boca-de-leão|f
boca-de-lobo|f
bochecha-de-velho|f
bodas|f
bódi|f
bodycam|f
bofé|f
boga|m
boi-de-corcova|m
boia-fria|m
boiola|m
boîte|f
boiz|f
boizinho|f
bola-ao-cesto|f
bola-de-berlim|f
bolacha-do-mar|f
boleima|f
bolo-rainha|m
bolonha|m
bolsa-estupro|f
bolsão|m
bom-dia|m
bomba-relógio|f
bombazine|f
borreliose|f
bosão|m
boto-cor-de-rosa|m
boutique|f
boyceta|m
brada|m
branquela|m
brasão|m
brema|f
brema-do-mar|f
bretã|f
breve|f
brigadeironha|m
brinco-de-princesa|m
brinco-de-viúva|m
brochista|m
broxa|m
brucelose|f
bruma|f
brumação|m
buda|m
busão|m
bútio-rabo-canela|m
butique|f
buzzword|f
cã|f
caá|f
caabopoxi|f
caaeé|f
caaingá|f
caamembeca|m
caami|f
cabeção|m
cabelo-de-velha|m
cabine|f
cabo-de-secção|m
cabra-de-leque|f
cabra-montês|f
cabre|f
cação|m
cachorrinho-da-terra|m
cacura|m
café-arábica|m
cafezista|m
cágado-de-pescoço-de-cobra|m
caixa-prego|f
caixa-segredo|f
cajá-manga|m
cal|f
çalá|f
calamidades|f
calção|m
calças|f
calendas|f
cálice|m
califa|m
calma|f
calvície|f
cama|f
cambadela|m
camião-cisterna|m
caminhão-pipa|m
caminhonete|f
camionete|f
camisa-castanha|m
camisa-de-vénus|f
camisa-de-vênus|f
camisa-parda|m
camisão|m
campeã|f
cana-de-açúcar|f
canabe|f
canábis|f
cânabis|f
canarinho|f
canário-da-terra|m
cancanista|m
candidíase|f
caneta-fonte|f
caneta-tinteiro|f
cão-da-pradaria|m
cão-de-água|m
cão-guia|m
cão-salsicha|m
capanga|m
capeta|m
capitã|f
capital|f
capitular|f
capixaba|m
capotagens|f
cara-de-lata|m
cara-metade|f
caraíba|m
carboxipeptidase|f
cariátide|f
cárie|f
carioca|m
carioquinha|m
carne|f
caroçama|f
carpa-capim|f
carpete|f
carro-bomba|m
carthaginez|m
caruma|f
casa-mãe|f
casbá|f
cascavel|f
castanha-da-índia|m
castanha-de-caju|f
castanha-do-pará|f
castanheira|m
castanheiro-da-índia|m
castelã|f
catábase|f
catacrese|f
catalã|f
catálise|f
catamita|m
catarse|f
catástrofe|f
catechese|f
catedral|f
catequese|f
catexe|f
catgirl|f
cati|f
catira|m
causal|f
cave|f
cê-cedilha|m
cebolinha-verde|f
celá|f
celà|f
celeuma|f
celta|m
celtista|m
célula-tronco|f
celulase|f
celulose|f
centáurea-menor|f
central|f
cercanias|f
ceroulas|f
certidão|f
cervical|f
cérvix|f
cerviz|f
cestodíase|f
cetose|f
chã|f
chacra|m
chakra|m
chama|f
chamma|f
champanha|m
chance|f
changana|m
chanson|f
chapéu-de-chuva|m
charge|f
charlatã|f
charrete|f
chave|f
chi-coração|m
chibanca|m
chica|m
chima|f
chuchunese|f
chuinga|m
chupa-cabra|m
chupa-chupa|m
chusma|f
ci-sena|m
cia.|f
cicloactivista|m
cicloide|f
ciclóide|f
cicloxigenase|f
cidadã|f
cidade-dormitório|f
cidade-estado|f
cidade-fantasma|f
cifose|f
cima|f
cinase|f
cincoenta|m
cineasta|m
cinetose|f
cingala|m
cinquenta|m
cinqùenta|m
cinqüenta|m
cinzas|f
cipó-catinga|m
cipó-d'água|m
cipó-da-mata|m
cipó-de-cobra|m
cipó-de-leite|m
cipó-escada|m
cipó-jiboia|m
cipó-jibóia|m
cipó-prata|m
cipó-quina|m
cipó-titica|m
cipó-tuíra|m
cipoama|f
circular|f
cirista|m
cirrose|f
cirurgiã|f
cisena|m
cisma|f
citocinese|f
citopatologista|m
claque|f
clasmocitose|f
classe|f
clave|f
clérgima|f
cloracne|f
clorose|f
co-secante|f
co-tangente|f
coala|m
coalizão|f
cobra-capelo|f
cobra-coral|f
cobra-de-água-de-colar|f
cobra-de-capelo|f
cobra-de-vidro|f
cobra-real|f
coccidiose|f
cocó|f
cócoras|f
códice|m
codorna-comum|f
codorniz|f
cohorte|f
coice|m
coima|f
coisa-em-si|f
colher|f
color|f
colorista|m
colunar|f
coma|f
comadre|f
combustão|f
cometa|m
comichão|f
commoção|m
commodity|f
compaixão|f
completidão|f
comu|f
concidadã|f
conclavista|m
condicional|f
condor-da-califórnia|m
conexão|f
confusaõ|f
congestão|f
connexão|f
conservante|f
consoante|f
consonante|f
constante|f
contra-mão|f
contra-reforma|f
contrafase|f
contramão|f
contraparte|f
contrarreforma|f
convez|m
convite|m
coorte|f
copas|f
copirraite|m
copo-de-leite|m
copta|m
coqueluche|f
cor|f
côr|f
cor-de-laranja|m
cor-de-rosa|m
côr-de-rosa|m
coração|m
cordovão|f
coresma|f
coringa|m
cornaca|m
coroinha|m
corré|f
corrente|f
côrte|f
cortesã|f
cortesão|m
córtice|m
coruja-das-neves|f
coruja-das-torres|f
coruja-do-mato|f
cosmogénese|f
cosmogênese|f
cosmópole|f
cosmópolis|f
cossecante|f
costas|f
cotangente|f
couve|f
couve-coração|m
couve-de-bruxelas|f
couve-de-folhas|f
couve-flor|f
couve-nabo|f
couve-rábano|f
crase|f
cravo-da-índia|m
creação|m
creche|f
credencial|f
crevasse|f
criança-lobo|f
crianção|m
crió|f
cripto|f
criptoanálise|f
criptobiose|f
criptococose|f
criptoftalmo|f
criptosporidíase|f
crisálide|f
crise|f
crisma|f
cristã|f
croata|m
cromátide|f
cromátide-irmã|f
cronoespécie|f
crucifixão|f
crude|m
cruis|f
cruiz|f
cruz|f
crypto|f
cuanza|m
cuecas|f
cunhã|f
cunhantã|f
cunhatã|f
cúpido|f
curcuma|f
cúrcuma|f
curgete|f
curiangada|m
curimã|f
curinga|m
curtose|f
cuscuz-paulista|m
cuvete|f
d'essa|m
dada|m
dafne|f
dálmata|m
dama|f
damas|f
dan-top|f
darknet|f
deã|f
deca|m
deênfase|f
defecação|m
défice|m
deflexão|f
degringolade|f
dêixis|f
deleite|m
delicatesse|f
delicatessen|f
delta|m
demão|f
dendrita|m
dengue|f
dental|f
deprê|f
desamão|f
desfem|f
desidratase|f
desidrogenase|f
desmama|f
desordem|f
desoxirribose|f
déspota|m
desquite|m
destruiçaõ|f
devassidão|f
dez|m
dia|m
dia-a-dia|m
diabete|f
diabetes|f
diabo-da-tasmânia|m
diácope|f
díade|f
diaforase|f
diagonal|f
diálise|f
diapasão|m
diapedese|f
diartrose|f
diástole|f
diatribe|f
diegese|f
diérese|f
digestão|f
digital|f
dimensaõ|f
dina|m
dinamite|m
dinheirama|f
diocese|f
diretas|f
diurese|f
diversaõ|f
díxis|f
dlc|f
dlç|f
doidivana|m
dominatrix|f
dor|f
dorsal|f
dose|f
doudivana|m
dríade|f
druida|m
dura-máter|f
dzeta|m
e-girl|f
ebola|m
ébola|m
ecdise|f
ecese|f
echarpe|f
écharpe|f
economias|f
ectlipse|f
ectoparasita|m
efeméride|f
efemérides|f
efígie|f
égide|f
electrodiálise|f
electrólise|f
elefante-da-floresta|m
elefante-da-savana|m
elefantíase|f
eletrodiálise|f
eletroforese|f
eletrólise|f
elipse|f
ema|f
embude|m
émese|f
êmese|f
emphyteuse|f
empurra-empurra|m
enartrose|f
encampaçaõ|f
encaração|m
encefalocele|f
enchente|f
ênclise|f
endireita|m
endocitose|f
endometriose|f
endossimbiose|f
ênfase|f
enfeite|m
enfiteuse|f
engine|f
enosis|f
ênosis|f
enquete|f
entremez|m
enum|f
enumeraçaõ|f
enurese|f
enus.|f
enzima|f
epêntese|f
epenthese|f
epicicloide|f
epiciclóide|f
epícrise|f
epiderme|f
epidermólise|f
epigénese|f
epigênese|f
epiglote|f
epígrafe|f
epirogénese|f
epirogênese|f
epistaxe|f
epitrocoide|f
epitrocóide|f
epizeuxe|f
equimose|f
equipe|f
erva-de-bicho|f
erva-de-cão|f
erva-de-gato|f
erva-de-passarinho|f
erva-de-são-joão|f
erva-do-grão-prior|f
erva-doce|f
erva-dos-burros|f
erva-dos-cantores|f
erva-mate|f
ervanaria|m
ervilha-de-cheiro|f
escalpação|m
escama|f
escanção|m
esclerose|f
escondidas|f
escorrega|m
escravidão|f
escravoceta|m
escrivã|f
escrófulas|f
escuma|f
escuridão|f
esfinge|f
esgrima|f
espaço-nave|f
espaçonave|f
espada-de-são-jorge|f
espécie|f
espiã|f
espinho-agulha|m
espinho-de-agulha|m
espinho-de-cerca|m
espiral|f
espuma|f
esqueite|m
esquete|f
esquistossomose|f
estado-nação|m
estante|f
estase|f
estatal|f
estatização|m
estenose|f
estepe|f
estilóbata|m
estima|f
estirpe|f
estrada-de-ferro|f
estrangulação|m
estrela-de-davi|f
estrela-do-mar|f
estrige|f
estrofe|f
etiogénese|f
etiogênese|f
etnogênese|f
eubiose|f
eucariota|m
eudicotiledôneas|f
europeias|f
exª|f
exactidão|f
exatas|f
exatidão|f
exaustão|f
excomunhão|f
exegese|f
exéquias|f
exoplaneta|m
expertise|f
expiraçaõ|f
expo|f
exposiçaõ|f
extincçaõ|f
extra|m
fã-arte|f
fac-símile|f
face|f
fachis|f
facul|f
fagocitose|f
faisão|m
fajã|f
falange|f
falsiane|f
fama|f
fanarte|f
fanboyola|m
fanfa|m
fanfic|f
fanga|m
fanha-fanha|m
faringe|f
farma|f
farme|f
fase|f
fé|f
fè|f
febre|f
feijão-carioca|m
feijão-manteiga|m
felosa-comum|f
feminicida|m
fénix|f
fênix|f
fenoloxidase|f
férias|f
ferro-gusa|m
feta|m
feto-águia|m
fic|f
figo-da-índia|m
figueira-do-diabo|f
figueira-do-inferno|f
filaríase|f
filariose|f
filhó|f
filho-da-puta|m
filhós|f
filial|f
filoneísta|m
fim-de-semana|m
fimose|f
finanças|f
firma|f
fisio|f
fita-crepe|f
fita-do-mar|f
flama|f
flate|f
flegma|f
flete|f
fleugma|f
fleuma|f
flexão|f
flogose|f
flor|f
flôr|f
flor-de-lis|f
fml|f
foca-elefante|f
foca-monge-do-havaí|f
foca-monge-do-mediterrâneo|f
fogo-apagou|f
foliã|f
fome|f
fonte|f
fora|m
forma|f
fôrma|f
forma-pensamento|f
formiga-de-fogo|f
formiga-lava-pés|f
formiga-leão|f
fosfamina|m
fosfatase|f
fosfolipase|f
fotinho|f
foto|f
fotólise|f
fotossíntese|f
fouce|f
foz|f
frajola|m
francez|m
frango-d'água|m
frase|f
freela|m
freguez|m
freima|f
freira-do-alto|f
frente|f
fricçaõ|f
frigidaire|f
frila|m
frisão|m
fritas|f
frol|f
fronde|f
fronte|f
fror|f
frouma|f
frouxidão|f
fruta-do-conde|f
fruta-pão|f
frutose|f
ft|f
ftiríase|f
fujoshi|f
fula|m
fulô|f
funçaõ|f
funcçaõ|f
funcionária-fantasma|f
fungicida|m
fusca|m
futiba|m
gabardine|f
gafe|f
gag|f
gaita-de-beiços|f
gaita-de-foles|f
galactose|f
galé|f
galè|f
galilé|f
galinha-d'angola|m
gameta|m
gâmeta|m
garavato|f
garaveto|f
garça-real|f
garção|m
garçonete|f
garçonnière|f
gare|f
garote|n
gastrónoma|f
gastrônoma|f
gato-da-selva|m
gato-de-algália|m
gato-ferrugem|m
gato-selvagem|m
gaviã|f
gavião-de-cauda-curta|m
gavião-de-cauda-vermelha|m
gaze|f
geez|m
gema|f
génese|f
gênese|f
geneta|m
gens|f
gente|f
genti|f
gênti|f
genuflexão|f
gestante|f
gestão|f
gẽte|f
giardíase|f
gilete|f
gimnosperma|f
gira-gira|m
glace|f
glande|f
glasnost|f
glicocálice|m
glicólise|f
glicose|f
glória-da-manhã|f
glotal|f
glote|f
glucose|f
gnose|f
golfinho-nariz-de-garrafa|m
goma|f
gorila|m
gorjal|f
gosma|f
gostosão|m
governo-sombra|m
grabato|f
grade|f
grafite|m
gralha-azul|f
grama|f
gratidão|f
grauvaca|m
gravato|f
graxa-de-estudante|f
grei|f
greve|f
grife|f
grilo-toupeira|m
gripe|f
grippe|f
grulha|m
grumixama|f
guaipeca|m
guajajara|m
guaju-guaju|f
guarda-chuva|m
guarda-roupa|m
guardiã|f
guariba|m
guaxima|f
guaxima-do-mangue|f
gude|m
guerra-relâmpago|f
guloseima|f
guna|m
h|f
hádice|m
halitose|f
hallucinaçaõ|f
halucinaçaõ|f
halvah|f
hamamélide|f
hamamélis|f
hanseníase|f
hashtag|f
haste|f
havana|m
hecatombe|f
hematémese|f
hematêmese|f
hemocromatose|f
hemodiálise|f
hemólise|f
hemóstase|f
hendíade|f
hendíadis|f
hera-terrestre|f
herbicida|m
hexa|m
hexoquinase|f
hexose|f
hidrogenase|f
hidrolase|f
hidrólise|f
hidrose|f
hidrossere|f
hierofanta|m
higiene|f
hipálage|f
hipérbole|f
hipercinese|f
hipnose|f
hipófise|f
hipopótama|f
hipotaxe|f
hipótese|f
hipotrocoide|f
hipotrocóide|f
hiragana|m
histerese|f
histiócito|f
histiocitose|f
hitita|m
hodja|m
holandez|m
holerite|m
hollandez|m
homem-bala|m
homem-bomba|m
homem-hiena|m
homem-sereia|m
homeostase|f
hoplita|m
horeca|m
hortelã|f
hortelã-verde|f
hoste|f
hrs|f
hypnose|f
hypothese|f
ialorixá|f
ibixuma|f
iconóstase|f
ictiose|f
ifrita-de-coroa-azul|f
imensidão|f
imperial|f
impressam|f
impressaõ|f
imundície|f
indagação|m
indez|m
índice|m
indigestão|f
índole|f
inexactidão|f
inexatidão|f
inférias|f
inflexão|f
ingestão|f
inglez|m
ingratidão|f
inhaúma|f
inhuma|f
inimizade|f
inquice|m
inquirição|m
inquisição|m
insecticida|m
inseticida|m
integral|f
intempérie|f
interestadual|f
interface|f
internet|f
intro|f
iole|f
ioruba|m
iota|m
iris|f
íris|f
irlandez|m
irmã|f
irreligião|f
islandez|m
isoforma|f
isoterma|f
istriota|m
iurte|f
iyalorixá|f
jaçanã|f
jacupemba|m
jadeíte|f
jaez|m
jambo-rosa|m
janeiras|f
jante|f
jardim-de-infância|m
jardineiras|f
jasmim-pipoca|m
javre|f
jdanovista|m
jesuíta|m
jihad|f
joinha|m
jubarte|f
jugular|f
jurará-açu|f
jurararetê|f
jurdiçam|f
jurdiçaõ|f
jurema|f
jurisdiçam|f
jurisdiçaõ|f
jurisdicçam|f
jurisdicçaõ|f
jurubaça|m
jusante|f
kalash|f
kana|m
kasha|m
katakana|m
kemalista|m
kermesse|f
khutba|m
kimbanda|m
kizomba|m
koine|f
koiné|f
kombi|f
kombucha|m
kra|m
kudurista|m
kuna|m
kwanza|m
lã|f
labial|f
lace|f
lactama|f
lactase|f
lactose|f
lagarta-do-cartucho|f
lagrima|f
lágrima|f
lagryma|f
lágryma|f
laje|f
lajem|f
lama|f
lambda|m
lambujem|f
lamecha|m
lamela|m
lanchonete|f
lande|f
lápide|f
laranja-cravo|f
larice|m
laringal|f
laringe|f
laringeal|f
lassidão|f
lástima|f
lateral|f
latine|n
leão-da-montanha|m
leão-de-chácara|m
lebre|f
legendista|m
legging|f
leggings|f
legião|f
legislativas|f
lei|f
leilaõ|f
leishmaniose|f
leite|m
lente|f
lentidão|f
leptospirose|f
lesa-majestade|f
lesma|f
letã|f
ley|f
leylaõ|f
libras|f
libré|f
lide|f
lilau|f
lima|f
limerence|f
liminar|f
limite|m
limousine|f
limusine|f
lingala|m
lingerie|f
linguatulose|f
lipase|f
lipo|f
lipoxigenase|f
lise|f
litíase|f
litotes|f
lobismulher|f
lobo-d'alsácia|m
lobo-da-alsácia|m
lobo-da-tasmânia|m
lobo-da-terra|m
locomotiva-tênder|f
loganberry|f
loló|f
lombar|f
lontra-gigante|f
lordose|f
lore|f
louro-da-terra|m
lua-de-mel|f
lúcuma|f
lula-colossal|f
lula-de-humboldt|f
lula-gigante|f
lulu-da-pomerânia|m
luxemburguez|m
luz|f
má-fé|f
maçã|f
maçã-de-adão|f
macaco-aranha|m
macaco-cairara|m
macaco-da-noite|m
macaco-guariba|m
macaísta|m
mação|m
macro|f
macrorregião|f
macua|m
macuquinho-perereca|m
madala|m
madama|f
madame|f
mademoiselle|f
madre|f
mãe|f
mãe-de-santo|f
mafoma|f
magenta|m
magestade|f
magnoliídeas|f
magrã|f
magricela|m
magrizela|m
mãi|f
maid|f
maionese|f
maionnaise|f
majestade|f
malaiala|m
malamute-do-alasca|m
malícia-de-mulher|f
maltez|m
maltose|f
malva-comum|f
mama|f
mamã|f
mamãe|f
mamma|f
mana|m
manchete|f
mangal|f
mangalho|f
mangueiral|f
manhã|f
manham|f
manhê|f
manhua|m
manhwa|m
manicure|f
manif|f
manife|f
mansidão|f
mantra|m
maõ|f
mão|f
mão-pelada|m
mapa|m
mapô|f
mappa|m
maquete|f
máquina-de-escrever|f
maracanã|f
marambaia|m
marani|f
marata|m
maré|f
marginal|f
maria-mole|f
maria-rapaz|f
marica|m
marionete|f
marionette|f
marionnette|f
marisma|f
marmeleiro-da-índia|m
marquez|m
marquise|f
marrã|f
martelada|m
mascne|f
masculinista|m
mata-mata|m
matcha|m
matéria-prima|f
matiné|f
matinê|f
matinée|f
matrix|f
matsá|f
matusquela|m
matzá|f
máxima|f
mãy|f
mayonese|f
mayonnaise|f
mayonnese|f
mboi|f
meã|f
media|m
médico-legista|m
mega|m
megalópole|f
meia-final|f
meia-irmã|f
meia-luz|f
meio-dia|m
meiose|f
melquita|m
melro-d'água|m
menagerie|f
menhã|f
menham|f
menina-mulher|f
menine|n
meninge|f
menino-mija|m
menorá|f
mente|f
merce|f
mercê|f
meritíssima|f
merma|f
mermã|f
meruje|f
mesão|m
mesóclise|f
mesoderma|f
mesoderme|f
mesorregião|f
messe|f
mestre-sala|m
mestrecorrida|m
metade|f
metaloenzima|f
metamorfose|f
metamorphose|f
metanálise|f
metástase|f
metátese|f
metempsicose|f
metempsychose|f
metrópole|f
mexe-mexe|f
mez|m
mezena|m
micagem|m
micoplasma|f
micose|f
microarray|f
microrregião|f
miíase|f
milenrama|f
mínima|f
minissérie|f
minudência|m
miose|f
mirandez|m
miríade|f
mirindiba-bagre|f
mise-en-scène|f
misoneísta|m
mitene|f
mitose|f
mitra|m
mixomatose|f
mó|f
mobelha-grande|f
moce|n
moçx|n
moeda-ouro|f
moirama|f
moirisma|f
moksha|m
mole|f
molher|f
mónade|f
mônade|f
monarcha|m
monçam|f
monçaõ|f
monocasta|m
monooxigenase|f
montante|f
moral|f
morfogénese|f
morgue|f
morte|f
mosca-das-frutas|f
mosca-de-banheiro|f
mosca-de-estábulo|f
moto-quatro|f
motoneve|f
mouçam|f
mouçaõ|f
mouche|f
mourama|f
mourisma|f
mousse|f
moxibustão|f
msol|f
muamuna|m
mucama|f
muche|f
mucroara|m
mudra|m
mufana|m
muié|f
mulé|f
mulher|f
mulher-dama|f
mulher-homem|f
mulher-macho|f
mulher-objeto|f
mulherona|m
multidão|f
multimédia|m
multinacional|f
música-chiclete|f
musse|f
mussumé|f
mussumê|f
muxibas|f
mzr|f
nada|m
nadinha|m
nadraste|n
nadrinhe|n
náiade|f
namorade|n
nanoespuma|f
nao|f
nariz-de-cera|m
nasal|f
nasca|m
nascente|f
nau|f
náuseas|f
nave|f
nazca|m
ndungue|f
necatoríase|f
necrópole|f
necrose|f
nefrocalcinose|f
nefrolitíase|f
negre|n
negridão|f
neofilismo|f
neógala|m
neomulher|f
net|f
neurocirurgiã|f
neuroprótese|f
neuropsicologia|m
neurose|f
neve|f
newsletter|f
nhá|f
nhama|f
night|f
ninjete|f
nintendista|m
nirvana|m
nogueira-pecã|f
noitibó-da-europa|m
noma|f
norma|f
norueguez|m
notícias|f
noute|f
noventa|m
noyte|f
noz|f
ntxuva|m
nuance|f
nucleossíntese|f
nunca|m
núpcias|f
nuve|f
nuvem|f
oba-oba|m
óbice|m
obstruinte|f
ocasião|f
occasião|f
oceânide|f
octavó|f
ode|f
odonto|f
oitenta|m
ojíbua|m
ojibwa|m
okara|m
olho-d'água|m
oligoqueta|m
oma|f
ómega|m
ômega|m
omelette|f
ondatra|m
onfalocele|f
opinião|f
optimização|m
oqueá|f
oral|f
ordem|f
orelha-de-judas|f
órfã|f
organizaçaõ|f
órix-da-arábia|m
orogénese|f
orogênese|f
ortoclase|f
osmose|f
osteoartrose|f
osteogénese|f
osteogênese|f
osteonecrose|f
osteoporose|f
ouija|m
overdose|f
oxigenase|f
oxirredutase|f
p.|f
p****|f
pá|f
pág.|f
pagã|f
paia|m
paisana|m
paixão|f
pajola|m
palaíta|m
palatal|f
palavra-chave|f
palavra-ônibus|f
palavra-passe|f
palavra-valise|f
paleoarte|f
palma|f
palpite|m
palude|m
pampa|m
panaca|m
panapanã|f
panda|m
pandinha|m
pandita|m
pândita|m
panhonha|m
panqueque|f
pantomima|f
pão-de-galinha|m
pão-de-leite|m
papa-moscas|f
papai-mamãe|f
papel-manteiga|m
papel-moeda|m
papel-toalha|m
papete|f
para-arranca|m
para-brisa|m
pára-brisa|m
parafimose|f
paráfrase|f
parafusão|m
paralaxe|f
parasitose|f
parataxe|f
paratha|m
paratireoide|f
paratiroide|f
parede|f
parmesão|m
parolo|f
parótide|f
parte|f
partenogénese|f
partenogênese|f
partes|f
parvoíce|f
passa-palavra|m
passe-vite|m
password|f
pastora-alemã|f
pastoral|f
patente|f
pato-selvagem|m
patogénese|f
patogênese|f
patrasana|m
patrazana|m
pátria-mãe|f
patriarca|m
patriarcal|f
patriarcha|m
patureba|m
pau-d'áquila|m
pau-de-águia|m
pau-de-águila|m
pau-de-arara|m
pau-farinha|m
pau-pita|m
pau-rosa|m
paulistinha|m
paywall|f
paz|f
pé-de-atleta|m
pé-de-cabra|m
pé-de-cana|m
pé-de-galinha|m
pé-de-meia|m
pé-de-moça|m
pé-vela|m
peba|m
pecã|f
pederasta|m
pedicure|f
pedótriba|m
pedra-papel-tesoura|m
pedra-pomes|f
pega-azul|f
pega-pega|m
peixe-agulha|m
peixe-aranha|m
peixe-beta|m
peixe-bruxa|m
peixe-de-briga|m
peixe-espada|m
peixe-espátula|m
peixe-lapa|m
peixe-lua|m
peixe-zebra|m
peixinho-da-horta|m
pele|f
pelerine|f
peltasta|m
pelve|f
pélvis|f
pen|f
pentelheira|m
pentose|f
pera-abacate|f
pera-de-advogado|f
pera-maçã|f
pércida|m
perdiz|f
peregrinaçam|f
peregrinaçaõ|f
pereiro|f
perereca-de-banheiro|f
performance|f
perfórmance|f
periapside|f
periclase|f
perífrase|f
periguete|f
perimólise|f
peristalse|f
permanente|f
pernoite|m
perpendicular|f
persa|m
pertússis|f
pescotapa|m
peshmerga|m
pêssego-careca|m
peste|f
pesticida|m
pètalazinha|m
pevide|f
pez|m
phalange|f
phase|f
phimose|f
phlegma|f
phleugma|f
phleuma|f
phrase|f
physis|f
pia-máter|f
piaçá|f
piaga|m
pica-porta|m
picape|f
pick-up|f
pickup|f
picote|f
pimba|m
pimenta-do-reino|f
pinguim-adélia|m
pinguim-de-adélia|m
pintelheira|m
piolho-da-cabeça|m
piolho-de-cabeça|m
piolho-de-cobra|m
piracanjuba|m
piracema|f
piraíba|m
pirâmide|f
pirapitinga|m
piratinga|m
piriguete|f
pirólise|f
pisca-pisca|m
piteira-do-caribe|f
placa-mãe|f
planeta|m
planície|f
plantonista|m
plasmólise|f
plástico-bolha|m
plataforma|f
playlist|f
plebe|f
pleiba|m
pluma|f
pneumoconiose|f
poc|f
pocema|f
pochete|f
podiatra|m
podologista|m
poeta|m
polemarca|m
policrase|f
polimerase|f
poliose|f
pólis|f
poncã|f
ponte|f
pontífice|m
ponto-e-vírgula|m
pop.|f
porco-da-terra|m
porquinho-da-índia|m
porta-bagagem|m
portuguez|m
pós|f
pós-barba|m
pós-combustão|f
pose|f
posse|f
potestade|f
ppk|f
praia-mar|f
praxe|f
práxis|f
preá-da-índia|m
preamar|f
prece|f
precisaõ|f
preia-mar|f
preliminares|f
presidenciais|f
prima|f
primeira-dama|f
prisam|f
prisaõ|f
probleminha|m
probóscide|f
próclise|f
profeta|m
progénie|f
progênie|f
prognose|f
prole|f
prontidão|f
protease|f
proteólise|f
prótese|f
protista|m
protoplaneta|m
próxima|f
prr|f
psicanálise|f
psicose|f
psique|f
psoríase|f
psychanalyse|f
puã|f
publi|f
pula|m
pula-pula|m
pulhas|f
punção|m
quarenta|m
quaresma|f
quartola|m
quebra-cabeça|m
quebra-quebra|m
quediva|m
queima|f
quermesse|f
quest|f
questam|f
questaõ|f
questão|f
quetognata|m
quício|f
quilowatt-hora|m
quimbanda|m
químio|f
quimiossíntese|f
quinase|f
quiroginasta|m
quitinase|f
quitinete|f
quitridiomicose|f
quixima|f
quizomba|m
qüestão|f
rã|f
rã-touro|f
rabirruivo-de-testa-branca|m
rabo-de-saia|m
rabona|m
rábula|m
raís|f
raiz|f
raiz-forte|f
rajaa|m
ralé|f
rama|f
randola|m
rani|f
rapazola|m
raposa-do-ártico|f
raposa-do-cabo|f
raque|f
raquete|f
raquette|f
rasante|f
rasaõ|f
ratão-d'água|m
rato-toupeira|m
rave|f
razaõ|f
razão|f
ré|f
rebelião|f
rebite|m
rede|f
redoma|f
redutase|f
ref.|f
reflexão|f
reforma|f
região|f
regras|f
régua-tê|f
religião|f
rematrícula|m
reninoma|f
rentrée|f
reprise|f
réquie|f
res|f
rês|f
resaõ|f
resma|f
retama|f
reticências|f
retidão|f
retoma|f
retrete|f
reunião|f
revanche|f
rezaõ|f
rezão|f
ribose|f
rima|f
risca-de-giz|f
rocha-mãe|f
roda-gigante|f
rola-bosta|m
romã|f
ronga|m
rosa-de-cão|f
rosa-do-bem-fazer|f
rosa-dos-ventos|f
roulotte|f
rouquidão|f
ruiva-dos-tintureiros|f
ruivina|m
rulote|f
sã|f
sabiá-laranjeira|m
sabiá-poca|m
sabiá-una|m
sabiapoca|m
sacabuxa|m
sacarose|f
saccharose|f
saite|m
salá|f
salpinge|f
salvaçam|f
salvaçaõ|f
samba|m
samba-canção|m
samba-exaltação|m
samica|m
sancadilha|m
sandes|f
sanduba|m
sanguinária|m
sanguinária-do-canadá|f
santo-e-senha|m
são|m
sapinho-admirável-de-barriga-vermelha|m
satélite|m
satiríase|f
sátrapa|m
satyríase|f
saúde|f
saüde|f
saxã|f
sazão|f
schmier|f
schwa|m
sé|f
sebe|f
séc.|f
secante|f
secundinas|f
sede|f
sêde|f
sege|f
segunda-dama|f
seleçaõ|f
selecçaõ|f
selêucida|m
self-service|m
selfie|f
semente|f
semi-final|f
semibreve|f
semifinal|f
semínima|f
seminude|m
semivogal|f
senas|f
senhore|n
senhorx|n
sepse|f
sépsis|f
sequidão|f
serbo-croata|m
série|f
seriema|f
serpe|f
serpente|f
sertã|f
sertanista|m
servidão|f
servo-croata|m
sesma|f
sessenta|m
sete-cores-da-amazónia|m
sete-cores-da-amazônia|m
setenta|m
sezão|f
shotgun|f
sibilante|f
sifaca|m
sífilis|f
silepse|f
sílfide|f
sílice|m
simbiose|f
sinapse|f
sinarquia|m
síncope|f
síndroma|f
síndrome|f
sinédoque|f
sinhá|f
sinopse|f
sínquise|f
sintaxe|f
síntese|f
sintetase|f
sirene|f
siriarca|m
siringe|f
sístole|f
site|m
situação-problema|f
skill|f
skin|f
skincare|f
sniper|f
soante|f
soba|m
sobredose|f
sobrepeliz|f
sobrinhe|n
sofreguidão|f
solidão|f
solução-tampão|f
soma|f
sonysta|m
sopeira|m
sopinha-de-massa|m
sopista|m
soror|f
sóror|f
sorte|f
soruma|f
spa|m
sr.e|n
sre.|n
stack|f
start-up|f
startup|f
story|f
suã|f
suaçuapara|m
sub|f
sub-região|f
subárvore|f
subclasse|f
subespécie|f
subordem|f
substituinte|f
sucuri|f
sucursal|f
sudorese|f
sugestão|f
suíte|f
superdose|f
superficie|f
superfície|f
suprarrenal|f
suricata|m
surucuá-de-barriga-amarela|m
surucuá-de-barriga-dourada|m
surucuá-grande-de-barriga-amarela|m
surucucu|f
suruma|f
sutra|m
sylphide|f
syncope|f
syntaxe|f
t-shirt|f
taca|m
tag|f
tagetes|f
tágide|f
taipan|f
taka|m
talassa|m
talude|m
tamanduá-bandeira|m
tanatocenose|f
tanatose|f
tangente|f
tapa-boca|m
tapinha|m
tapuia|m
tarde|f
tartaruga-de-couro|f
tartaruga-de-galápagos|f
tartaruga-de-pente|f
tartaruga-do-amazonas|f
tartaruga-do-mar|f
tartaruga-matamatá|f
tartaruga-verde|f
tarte|f
tartelete|f
tataravó|f
tatu-bola|m
tatu-de-folha|m
tatu-galinha|m
táxi-lotação|m
tchola|m
tchova|m
tchutchuca|m
tecelã|f
tecnobrega|m
teima|f
telegramma|f
televangelista|m
televendas|f
telinga|m
tempestade|f
tenaz|f
tera|m
teratologista|m
terma|f
tesão|m
tese|f
tesla|m
teta|m
tetracampeã|f
tetradracma|f
tetravó|f
tevê|f
these|f
thread|f
tia-avó|f
tição|m
tie|n
tigre-da-tasmânia|m
tigre-de-bengala|m
tigre-de-sumatra|m
tigrínia|m
tigrinya|m
tiki-taka|m
time-lapse|f
tiriba|m
tiriva|m
tiroide|f
tiróide|f
titânide|f
tmese|f
toalete|f
toba|m
toboágua|m
toda|m
tôda|m
toilete|f
toilette|f
tomate-cereja|m
tonga|m
toolbox|f
topique|f
torre|f
tôrre|f
torrente|f
tosão|m
tosse|f
tosta-mista|m
toxicodependente|f
traça-de-livros|f
traça-dos-livros|f
traduçaõ|f
traducçaõ|f
traiçaõ|f
trama|f
trâmite|m
transgénere|n
transgênere|n
transversal|f
traqueíte|f
trás|f
trava-língua|m
trave|f
travessão|m
travesti|f
trealose|f
trem-bala|m
trend|f
três-marias|f
trevas|f
tríade|f
tríbade|f
tribo|f
tribu|f
tricampeã|f
tricomoníase|f
trienal|f
trinta|m
tripanossomíase|f
trirreme|f
trisavó|f
triz|m
troca-troca|m
trolha|m
trombose|f
tropicalidade|m
tropicalista|m
trotinete|f
trotskista|m
trupe|f
trusse|f
trusses|f
tsuga|m
tubarão-baleia|m
tubarão-da-groenlândia|m
tuberculose|f
tumbérgia-azul|f
tumorigénese|f
tumorigênese|f
turma|f
turné|f
turnê|f
tuxaua|m
tv|f
txopela|m
ubá|f
uje|f
ulti|f
última|f
ultravioleta|m
ummah|f
unha-de-asno|f
unha-de-cavalo|f
unha-de-gato|f
unhas-de-gato|f
união|f
unimama|f
urbe|f
urra|m
urubu-da-mata|m
urubu-de-cabeça-amarela|m
urubu-de-cabeça-preta|m
urubu-de-cabeça-vermelha|m
urubutinga|m
urze|f
uva-de-cão|f
uva-de-galo|f
uva-de-gato|f
uva-do-japão|f
uva-espim|f
uveíte|f
uzi|f
vã|f
vaguidão|f
valise|f
valor-verdade|m
van|f
vara-de-ouro|f
varejista|m
variante|f
variável|f
varicocele|f
variz|f
vastidaõ|f
vastidão|f
vavó|f
vazante|f
vazaõ|f
vazão|f
vdd|f
veado-de-cauda-branca|m
velar|f
ventã|f
verde-água|m
verde-azeitona|m
verde-esmeralda|m
verde-folha|m
verde-menta|m
verde-oliva|m
vermelhidão|f
verruma|f
vertente|f
vértice|m
vespa-do-mar|f
veste|f
vestiba|m
via-crúcis|f
vibe|f
víbora-do-gabão|f
vibrante|f
vide|f
vietnamita|m
view|f
vilã|f
vin-d'alho|f
vinca-de-madagáscar|f
vindima|f
vinha-d'alho|f
vinha-d'alhos|f
vinhadalhos|f
violaçaõ|f
violentação|m
vira|m
vira-latice|m
virago|f
viralatice|m
virose|f
visarga|m
visitação|m
vítima|f
vitrine|f
viv'alma|f
viva|m
vivalma|f
vó|f
vobla|m
vogal|f
voivoda|m
vomtade|f
vontade|f
vórtice|m
võtade|f
vovó|f
voz|f
vrdd|f
waifu|f
wawa|m
web|f
webcam|f
website|m
wiki|f
wishlist|f
wok|f
workstation|f
xadrez|m
xerez|m
xerolaine|f
xerpa|m
xhosa|m
xilose|f
xite|m
xituculumucumba|m
xixa|m
xossa|m
yakisoba|m
yakissoba|m
yield|f
yoruba|m
yurte|f
zé-droguinha|m
zénite|m
zênite|m
zeta|m
zoonose|f
`;

const PLURAL_DATA = `abacatal|abacatais
abacateiral|abacateirais
abacaxizal|abacaxizais
abade-geral|abades-gerais
abatis|abatises
abdal|abdais
abdominal|abdominais
abelha-mestra|abelhas-mestras
abelha-operária|abelhas-operárias
abelha-pedreira|abelhas-pedreiras
abelha-rainha|abelhas-rainha
abeto-de-douglas|abetos-de-Douglas
abeto-vermelho|abetos-vermelhos
abóbora-menina|abóboras-meninas
abôrto|abortos
abricó-do-pará|abricós-do-pará
abrótano-macho|abrótanos-machos
abrunheiro-bravo|abrunheiros-bravos
abutre-barbudo|abutres-barbudos
abutre-fusco|abutres-fuscos
açafrão-da-terra|açafrões-da-terra
acará-bandeira|acarás-bandeiras
acêrto|acertos
acetal|acetais
acórdão|acórdãos
acôrdo|acordos
açucenal|açucenais
adhesaõ|adhesoens
adição-padrão|adições-padrões
adôrno|adornos
afegão|afegãos
after|afters
agapornis|agapornises
aggiornamento|aggiornamenti
agôsto|agostos
agrião-dos-prados|agriões-dos-prados
agrocombustível|agrocombustíveis
água-benta|águas-bentas
água-de-cheiro|águas-de-cheiro
água-de-colónia|águas-de-colónia
água-de-colônia|águas-de-colônia
água-forte|águas-fortes
água-má|águas-más
água-marinha|águas-marinhas
água-tinta|águas-tintas
água-viva|águas-vivas
aguaçal|aguaçais
águia-caçadeira|águias-caçadeiras
águia-calçada|águias-calçadas
águia-cobreira|águias-cobreiras
águia-de-asa-redonda|águias-de-asa-redonda
águia-dourada|águias-douradas
águia-imperial-ibérica|águias-imperiais-ibéricas
águia-pequena|águias-pequenas
águia-pesqueira|águias-pesqueiras
águia-pesqueira-africana|águias-pesqueiras-africanas
águia-real|águias-reais
aí-pixuna|aís-pixunas
aipo-rábano|aipos-rábano
alcohol|alcohoes
alcool|alcooes
álcool|álcoois
alemão|alemães
alemão-ocidental|alemão-ocidentais
alemão-oriental|alemão-orientais
alfinete-de-ama|alfinetes-de-ama
alfinete-de-bebé|alfinetes-de-bebé
alfinete-de-dama|alfinetes-de-dama
alfinete-de-fralda|alfinetes-de-fralda
algodão-da-praia|algodões-da-praia
algodão-de-seda|algodões-de-seda
algodão-doce|algodões-doces
algodoal|algodoais
algodoeiro-da-praia|algodoeiros-da-praia
alho-francês|alhos-franceses
alho-poró|alhos-porós
alho-porro|alhos-porros
allegretto|allegretti
allegro|allegri
allucinaçaõ|allucinaçoens
almôço|almoços
alquilmetal|alquilmetais
altar-mor|altares-mores
alto-astral|altos-astrais
alto-forno|altos-fornos
alto-relevo|altos-relevos
alúmen|alúmenes
alvéola-branca|alvéolas-brancas
alvorôço|alvoroços
alvorôto|alvorotos
ama-de-leite|amas-de-leite
ama-seca|amas-secas
amêijoa-gigante|amêijoas-gigantes
amendoeira-da-praia|amendoeiras-da-praia
ametal|ametais
amial|amiais
amieiral|amieirais
amiga-da-onça|amigas-da-onça
amiga-ursa|amigas-ursas
amigável|amigáveis
amigo-da-onça|amigos-da-onça
amigo-urso|amigos-ursos
amor-perfeito|amores-perfeitos
amor-próprio|amores-próprios
amora-preta|amoras-pretas
amora-silvestre|amoras-silvestres
amoreira-preta|amoreiras-pretas
ampere-espira|amperes-espiras
ampère-espira|ampères-espiras
anã-vermelha|anãs-vermelhas
anal|anais
andorinha-das-barreiras|andorinhas-das-barreiras
andorinha-das-chaminés|andorinhas-das-chaminés
andorinha-de-bando|andorinhas-de-bando
andorinha-do-mar|andorinhas-do-mar
andorinha-dos-beirais|andorinhas-dos-beirais
anémona-do-mar|anémonas-do-mar
anêmona-do-mar|anêmonas-do-mar
angstrom|angstroms
ångström|ångströms
animal|animais
animalzão|animaizões
animalzinho|animaizinhos
anis|anises
anis-estrelado|anises-estrelados
annal|annaes
annel|anneis
ano-bom|anos-bons
ano-luz|anos-luz
ano-maço|anos-maço
ano-novo|anos-novos
anonymizer|anonymizers
ansível|ansíveis
antélix|antélices
antemão|antemãos
antemural|antemurais
anti-hélix|anti-hélices
anticlinal|anticlinais
anticoncepcional|anticoncepcionais
anticristão|anticristãos
antideus|antideuses
antidiagonal|antidiagonais
antigripal|antigripais
antimonial|antimoniais
antirretroviral|antirretrovirais
antiviral|antivirais
apelaçam|apelações
apelaçaõ|apelaçoens
apellaçam|apellações
apellaçaõ|apellaçoens
apêlo|apelos
apêrto|apertos
apfelstrudel|apfelstrudels
apical|apicais
appelaçam|appelações
appelaçaõ|appelaçoens
appellaçam|appellações
appellaçaõ|apellaçoens
approach|approaches
aprêço|apreços
ar-condicionado|ares-condicionados
arando-vermelho|arandos-vermelhos
aranha-lobo|aranhas-lobo
aranha-marrom|aranhas-marrons
araticum-do-brejo|araticuns-do-brejo
arbusto-da-independência|arbustos-da-independência
arco-da-velha|arcos-da-velha
arco-íris|arcos-íris
areal|areais
argilomineral|argilominerais
aridisol|aridisols
armorial|armoriais
arraia-miúda|arraias-miúdas
arraial|arraiais
arrátel|arráteis
arrôjo|arrojos
arrôto|arrotos
arrozal|arrozais
arsenal|arsenais
artesão|artesãos
árvore-da-independência|árvores-da-independência
árvore-da-morte|árvores-da-morte
árvore-da-vida|árvores-da-vida
arzinho|arezinhos
asa-branca|asas-brancas
assembly|assemblies
astral|astrais
atascal|atascais
atelier|ateliers
atêrro|aterros
audiência-alvo|audiências-alvo
austral|austrais
austro-alemão|austro-alemães
auteur|auteurs
automóvel|automóveis
aval|avais
ave-do-paraíso|aves-do-paraíso
ave-fria|aves-frias
avental|aventais
aviãozão|aviõezões
azul-bebé|azuis-bebé
azul-celeste|azuis-celestes
azul-cobalto|azuis-cobalto
azul-marinho|azuis-marinhos
azul-petróleo|azuis-petróleo
azul-real|azuis-reais
azulzinho|azuizinhos
babosa-brava|babosas-bravas
bacanal|bacanais
baga-de-freira|bagas-de-freiras
bagel|bagels
bagual|baguais
baixo-astral|baixos-astrais
baixo-império|baixos-impérios
baixo-relevo|baixos-relevos
balaõ|baloens
balãozinho|balõezinhos
baleia-anã|baleias-anãs
baleia-assassina|baleias-assassinas
baleia-azul|baleias-azuis
baleia-boreal|baleias-boreais
baleia-comum|baleias-comuns
baleia-corcunda|baleias-corcundas
baleia-fin|baleias-fin
baleia-franca|baleias-francas
baleia-jubarte|baleias-jubarte
baleia-piloto|baleias-piloto
baleia-sei|baleias-sei
ballaõ|balloens
bambual|bambuais
bambuzal|bambuzais
banana-comprida|bananas-compridas
banana-da-terra|bananas-da-terra
banhadal|banhadais
banner|banners
barão-ladrão|barões-ladrões
barba-de-velho|barbas-de-velho
barco-dragão|barcos-dragão
barman|barmen
barriga-branca|barrigas-brancas
batata-da-terra|batatas-da-terra
batata-doce|batatas-doces
batata-roxa|batatas-roxas
batatal|batatais
batateiral|batateirais
bazofiador|bazofiadora
beatbox|beatboxes
beija-flor-de-barriga-branca|beija-flores-de-barriga-branca
beija-flor-de-fronte-violeta|beija-flores-de-fronte-violeta
beija-flor-de-garganta-verde|beija-flores-de-garganta-verde
beija-flor-de-orelha-violeta|beija-flores-de-orelha-violeta
beija-mão|beija-mãos
beiral|beirais
bênção|bênçãos
bernardo-eremita|bernardos-eremitas
besouro-bombardeiro|besouros-bombardeiros
besouro-da-batata|besouros-da-batata
best-seller|best-sellers
besta-fera|bestas-feras
bestseller|bestsellers
beterraba-sacarina|beterrabas-sacarinas
bicha-alfinete|bichas-alfinete
bicha-amarela|bichas-amarelas
bicha-cadela|bichas-cadelas
bicha-do-milho|bichas-do-milho
bicha-solitária|bichas-soliárias
bicho-carpinteiro|bichos-carpinteiros
bicho-da-farinha|bichos-da-farinha
bicho-da-seda|bichos-da-seda
bicho-de-conta|bichos-de-conta
bicho-de-sete-cabeças|bichos-de-sete-cabeças
bicho-geográfico|bichos-geográficos
bicho-gordo|bichos-gordos
bicho-grilo|bichos-grilos
bicho-papão|bichos-papões
bicho-preguiça|bichos-preguiça
bico-de-lacre|bicos-de-lacre
bienal|bienais
bilabial|bilabiais
biocombustível|biocombustíveis
bisão-americano|bisões-americanos
bisão-europeu|bisões-europeus
bisonte-americano|bisontes-americanos
bisonte-europeu|bisontes-europeus
bissemanal|bissemanais
blazer|blazers
blêizer|blêizers
blitzkrieg|blitzkriege
blockbuster|blockbusters
blogger|bloggers
blóguer|blóguers
blush|blushes
boa-fé|boas-fés
boa-noite|boas-noites
boa-tarde|boas-tardes
bob|bobes
bobo-pequeno|bobos-pequenos
boca-de-fumo|bocas-de-fumo
boca-de-incêndio|bocas-de-incêndio
boca-de-leão|bocas-de-leão
boca-de-lobo|bocas-de-lobo
boca-livre|bocas-livres
bocal|bocais
boçal|boçais
bochecha-de-velho|bochechas-de-velho
bodião-do-alto|bodiões-do-alto
body|bodies
bodycam|bodycams
boi-almiscarado|bois-almiscarados
boi-de-corcova|bois-de-corcova
boia-fria|boias-frias
bola-de-berlim|bolas-de-berlim
bolacha-da-praia|bolachas-da-praia
bolacha-do-mar|bolachas-do-mar
bôlo|bolos
bolo-rainha|bolos-rainhas
bolo-rei|bolos-reis
bolsa-estupro|bolsas-estupro
bôlso|bolsos
bom-dia|bons-dias
bom-tom|bons-tons
bomba-relógio|bombas-relógio
boom|booms
borboleta-cauda-de-andorinha|borboletas-cauda-de-andorinha
bornal|bornais
borzegui|borzeguins
botãozinho|botõezinhos
boto-cor-de-rosa|botos-cor-de-rosa
bottom|bottoms
boxer|boxers
boxeur|boxeurs
braçal|braçais
bradal|bradais
brandal|brandais
brandy|brandies
braquial|braquiais
braquiorradial|braquiorradiais
brejal|brejais
brema-do-mar|bremas-do-mar
brigadeiro-general|brigadeiros-generais
brinco-de-princesa|brincos-de-princesa
brinco-de-viúva|brincos-de-viúva
brócolos|brócolis
bróder|bróders
brother|brothers
brôto|brotos
brunch|brunches
buçal|buçais
búfalo-asiático|búfalos-asiáticos
buffer|buffers
bufo-real|bufos-reais
bugio-ruivo|bugios-ruivos
bunker|bunkers
bureau|bureaux
burger|burgers
burguer|burguers
busdoor|busdoors
bútio-rabo-canela|bútios-rabo-canela
cabeçal|cabeçais
cabedal|cabedais
cabo-de-secção|cabos-de-secção
cabra-de-leque|cabras-de-leque
cabra-montês|cabras-monteses
cabra-montesa|cabras-montesas
cabra-selvagem|cabras-selvagens
caçador-coletor|caçadores-coletores
caçador-recolector|caçadores-recolectores
caçador-recoletor|caçadores-recoletores
caçadora-recolectora|caçadoras-recolectoras
caçadora-recoletora|caçadoras-recoletoras
cação-anjo|cações-anjo
cachorrinho-da-terra|cachorrinhos-da-terra
cachorro-do-mato|cachorros-do-mato
cachorro-quente|cachorros-quentes
cadaval|cadavais
cafezal|cafezais
cágado-de-pescoço-comprido|cágados-de-pescoço-comprido
cágado-de-pescoço-de-cobra|cágados-pescoço-de-cobra
caixa-alta|caixas-altas
caixa-d'água|caixas-d'água
caixa-negra|caixas-negras
caixa-preta|caixas-pretas
caixa-segredo|caixas-segredo
cajón|cajones
calcanhar-de-aquiles|calcanhares-de-Aquiles
caldo-verde|caldos-verdes
cálix|cálices
call|calls
camal|camais
camião-cisterna|camiões-cisterna
caminhão-pipa|caminhões-pipa
caminhão-tanque|caminhões-tanque
caminho-de-ferro|caminhos-de-ferro
camisa-castanha|camisas-castanhas
camisa-de-vénus|camisas-de-vénus
camisa-de-vênus|camisas-de-vênus
camisa-marrom|camisas-marrons
camisa-parda|camisas-pardas
campus|campi
cana-da-índia|canas-da-índia
cana-de-açúcar|canas-de-açúcar
cana-índica|canas-índicas
canal|canais
canário-da-terra|canários-da-terra
canavial|canaviais
canela-preta|canelas-pretas
canibal|canibais
cânon|cânones
cão|cães
cão-da-pradaria|cães-da-pradaria
cão-de-água|cães-de-água
cão-dos-prados|cães-dos-prados
cão-miúdo|cães-miúdos
cão-pastor|cães-pastores
cão-salsicha|cães-salsichas
cãozarrão|cãezarrões
cãozinho|cãezinhos
cãozito|cãezitos
cap.|caps.
capelão|capelães
capim-doce|capins-doces
capim-limão|capins-limão
capinzal|capinzais
capital|capitais
capitam|capitães
capitaõ|capitaens
capitão|capitães
capitão-do-mato|capitães-do-mato
caporal|caporais
caput|capita
cara-de-lata|caras-de-lata
cara-metade|caras-metades
caracal|caracais
carácter|caracteres
caravela-portuguesa|caravelas-portuguesas
cardeal|cardeais
cardinal|cardinais
carnaval|carnavais
carniçal|carniçais
carpa-capim|carpas-capim
cartão-postal|cartões-postais
carthaginês|cartagineses
caruru-azedo|carurus-azedos
carvalhal|carvalhais
carvalho-português|carvalhos-portugueses
casa-mãe|casas-mãe
casaca-de-couro-da-lama|casacas-de-couro-da-lama
casal|casais
cascal|cascais
castanha-da-índia|castanheiros-da-índia
castanha-de-caju|castanhas-de-caju
castanha-do-pará|castanhas-do-pará
castanheira-da-índia|castanheiras-da-índia
castanheira-do-pará|castanheiras-do-pará
castanheiro-da-índia|castanheiros-da-índia
castanheiro-do-pará|castanheiros-do-pará
castiçal|castiçais
catalão|catalães
catedral|catedrais
catgirl|catgirls
caudal|caudais
causal|causais
cavala-da-índia|cavalas-da-índia
cavalinho-de-deus|cavalinhos-de-deus
cavalo-de-przewalski|cavalos-de-przewalski
cavalo-marinho|cavalos-marinhos
cavalo-vapor|cavalos-vapor
cê-cedilhado|cês-cedilhados
cebolinha-verde|cebolinhas-verdes
cegonha-branca|cegonhas-brancas
ceifeira-debulhadora|ceifeiras-debulhadoras
cel|cels
célula-tronco|células-tronco
cenoura-brava|cenouras-bravas
centáurea-menor|centáureas-menores
central|centrais
cepstrum|cepstra
cereal|cereais
cervical|cervicais
cérvix|cérvices
chá-bravo|chás-bravos
chacal|chacais
chacal-dourado|chacais-dourados
chaõ|chaons
chão|chãos
chapéu-coco|chapéus-coco
chapéu-de-chuva|chapéus-de-chuva
chapéu-de-coco|chapéus-de-coco
chapéu-de-côco|chapéus-de-côco
chapéu-de-napoleão|chapéus-de-napoleão
chapéu-de-sol|chapéus-de-sol
chapim-azul|chapins-azuis
chapim-preto|chapins-pretos
chapim-real|chapim-reais
charácter|characteres
chasside|chassidim
chave-mestra|chaves-mestras
checksum|checksums
cheddar|cheddars
cheeseburger|cheeseburgers
cheeseburguer|cheeseburguers
cheiro-verde|cheiros-verdes
chimbal|chimbais
chôro|choros
choupo-tremedor|choupos-tremedores
christão|christãos
ci-sena|cis-senas
cia.|cias.
cidadam|cidadãos
cidadão|cidadãos
cifraõ|cifroens
cinejornal|cinejornais
cipó-branco|cipós-brancos
cipó-cabeludo|cipós-cabeludos
cipó-caboclo|cipós-caboclos
cipó-camarão|cipós-camarão
cipó-catinga|cipós-catinga
cipó-chumbo|cipós-chumbo
cipó-cravo|cipós-cravo
cipó-cruz|cipós-cruz
cipó-cururu|cipós-cururu
cipó-d'água|cipós-d'água
cipó-d'alho|cipós-d'alho
cipó-da-mata|cipós-da-mata
cipó-de-boi|cipós-de-boi
cipó-de-cobra|cipós-de-cobra
cipó-de-fogo|cipós-de-fogo
cipó-de-imbé|cipós-de-imbé
cipó-de-leite|cipós-de-leite
cipó-de-macaco|cipós-de-macaco
cipó-de-morcego|cipós-de-morcego
cipó-de-são-joão|cipós-de-são-joão
cipó-de-sapo|cipós-de-sapo
cipó-escada|cipós-escada
cipó-florão|cipós-florões
cipó-imbé|cipós-imbé
cipó-jiboia|cipós-jiboia
cipó-jibóia|cipós-jibóia
cipó-mata-cobras|cipós-mata-cobras
cipó-matador|cipós-matadores
cipó-mil-homens|cipós-mil-homens
cipó-pau|cipós-pau
cipó-prata|cipós-prata
cipó-preto|cipós-pretos
cipó-quina|cipós-quina
cipó-suma|cipós-suma
cipó-timbó|cipós-timbó
cipó-titica|cipós-titica
cipó-tuíra|cipós-tuíra
cipó-unha-de-boi|cipós-unha-de-boi
cipó-unha-de-gato|cipós-unha-de-gato
cipoal|cipoais
cipozal|cipozais
ciprestal|ciprestais
cisne-mudo|cisnes-mudos
cisne-negro|cisnes-negros
cisne-real|cisnes-reais
cluster|clusters
cobra-capelo|cobras-capelo
cobra-coral|cobras-corais
cobra-de-água-de-colar|cobras-de-água-de-colar
cobra-de-capelo|cobras-de-capelo
cobra-de-escada|cobras-de-escada
cobra-de-vidro|cobras-de-vidro
cobra-lisa-austríaca|cobras-lisas-austríacas
côbro|cobros
cocal|cocais
códex|códices
código-fonte|códigos-fonte
codorna-comum|codornas-comuns
cogumelo-do-sol|cogumelos-do-sol
coisa-em-si|coisas-em-si
colmeal|colmeais
cólofon|colofones
combustível|combustíveis
comêço|começos
comercial|comerciais
concidadão|concidadãos
condestável|condestáveis
condicional|condicionais
condor-da-califórnia|condores-da-califórnia
condor-dos-andes|condores-dos-andes
confôrto|confortos
confusaõ|confusoens
cônsul|cônsules
container|containers
contôrno|contornos
contra-mão|contra-mãos
contramão|contramãos
control|controls
contrôlo|controlos
conversível|conversíveis
cool|cools
cooler|coolers
copo-de-leite|copos-de-leite
coração-de-boi|corações-de-boi
coraçãozinho|coraçõezinhos
coral|corais
cordufal|cordufais
coronal|coronais
corporal|corporais
corpus|corpora
córpus|córpora
correcional|correcionais
cortesão|cortesãos
coruja-buraqueira|corujas-buraqueiras
coruja-das-neves|corujas-das-neves
coruja-das-torres|corujas-das-torres
coruja-do-mato|corujas-do-mato
cotaõ|cotoens
couve-chinesa|couves-chinesas
couve-de-bruxelas|couves-de-bruxelas
couve-de-folhas|couves-de-folhas
couve-galega|couves-galegas
couve-lombarda|couves-lombardas
couve-nabiça|couves-nabiças
couve-nabo|couves-nabo
couve-portuguesa|couves-portuguesas
couve-rábano|couves-rábano
couve-tronchuda|couves-tronchudas
côvão|côvãos
cowbell|cowbells
crash|crashes
cravo-da-índia|cravos-da-índia
credencial|credenciais
criado-mudo|criados-mudos
criança-lobo|crianças-lobo
cristal|cristais
cristão|cristãos
cromátide-irmã|cromátides-irmãs
crossover|crossovers
cunhã-poranga|cunhãs-porangas
cunhal|cunhais
cuproníquel|cuproníqueis
curral|currais
cuscuz-paulista|cuscuzes-paulistas
cyprestal|cyprestaes
debugger|debuggers
decátlon|decátlones
decimal|decimais
decôro|decoros
dedal|dedais
delivery|deliveries
demão|demãos
dental|dentais
dente-de-leão|dentes-de-leão
deos|deoses
descapotável|descapotáveis
desespêro|desesperos
desfem|desfems
desnível|desníveis
desprêzo|desprezos
destruiçaõ|destruiçoens
desvão|desvãos
deus|deuses
deus-rio|deuses-rio
diabo-da-tasmânia|diabos-da-tasmânia
diagonal|diagonais
diamante-mandarim|diamantes-mandarim
diesel|diesels
diferencial|diferenciais
digital|digitais
dimensaõ|dimensoens
diner|diners
direção-geral|direções-gerais
diretor-geral|diretores-gerais
dirigível|dirigíveis
dísel|díseis
dita-cuja|ditas-cujas
dito-cujo|ditos-cujos
diversaõ|diversoens
dôbro|dobros
doce-amarga|doces-amargas
dolce-amarga|dolces-amargas
dominatrix|dominatrixes
dona-de-casa|donas-de-casa
doninha-fedorenta|doninhas-fedorentas
doppelganger|doppelgangers
dorsal|dorsais
dossier|dossiers
dox|doxes
dragão-de-comodo|dragões-de-comodo
dragãozinho|dragõezinhos
dreidel|dreidels
dril|drils
driver|drivers
duodecimal|duodecimais
e-girl|e-girls
e-mail|e-mails
edital|editais
editorial|editoriais
electrão-volt|electrões-volt
elefante-africano|elefantes-africanos
elefante-asiático|elefantes-asiáticos
elefante-da-floresta|elefantes-da-floresta
elefante-da-savana|elefantes-da-savana
elefante-marinho|elefantes-marinhos
eletrão-volt|eletrões-volt
email|emails
embornal|embornais
encampaçaõ|encampaçoens
engôdo|engodos
enguia-elétrica|enguias-elétricas
enum|enums
enumeraçaõ|enumeraçoens
enxoval|enxovais
ep.|eps.
ermão|ermãos
êrro|erros
ersatz|ersätze
erva-bezerra|ervas-bezerras
erva-cicutária|ervas-cicutárias
erva-cidreira|ervas-cidreiras
erva-de-bicho|ervas-de-bicho
erva-de-cão|ervas-de-cão
erva-de-passarinho|ervas-de-passarinho
erva-de-são-joão|ervas-de-são-joão
erva-do-grão-prior|ervas-do-grão-prior
erva-doce|ervas-doces
erva-dos-burros|ervas-dos-burros
erva-dos-cantores|ervas-dos-cantores
erva-férrea|ervas-férreas
erva-mate|ervas-mate
ervilha-de-cheiro|ervilhas-de-cheiro
escorpião-amarelo|escorpiões-amarelos
escrevedeira-amarela|escrevedeiras-amarelas
escrivão|escrivães
esfôrço|esforços
esgôto|esgotos
esnórquel|esnórquels
espada-de-são-jorge|espadas-de-são-jorge
espécimen|especímenes
espêto|espetos
espinheiro-preto|espinheiros-pretos
espinho-agulha|espinhos-agulha
espinho-branco|espinhos-brancos
espinho-de-agulha|espinhos-de-agulha
espinho-de-carneiro|espinhos-de-carneiro
espinho-de-cerca|espinhos-de-cerca
espinho-de-cristo|espinhos-de-cristo
espinho-de-jerusalém|espinhos-de-jerusalém
espinho-de-maricá|espinhos-de-maricá
espiral|espirais
espital|espitaes
espôso|esposos
estatal|estatais
estendal|estendais
estôfo|estofos
estôrno|estornos
estrada-de-ferro|estradas-de-ferro
estrela-de-davi|estrelas-de-davi
estrela-do-mar|estrelas-do-mar
eu-lírico|eus-líricos
eucaliptal|eucaliptais
exagêro|exageros
éxon|exons
expiraçaõ|expiraçoens
exposiçaõ|exposiçoens
extincçaõ|extincçoens
factorial|factoriais
facul|faculs
faia-preta|faias-pretas
faial|faiais
faláfel|faláfeis
falcão-americano|falcões-americanos
falcão-peregrino|falcões-peregrinos
fandom|fandoms
fato-de-macaco|fatos-de-macaco
fatorial|fatoriais
fax|faxes
fecho-relâmpago|fechos-relâmpago
federal|federais
feijão-branco|feijões-brancos
feijão-carioca|feijões-cariocas
feijão-carito|feijões-caritos
feijão-casado|feijões-casados
feijão-caupi|feijões-caupi
feijão-comum|feijões-comuns
feijão-de-frade|feijões-de-frade
feijão-de-porco|feijões-de-porco
feijão-de-tropeiro|feijões-de-tropeiro
feijão-encarnado|feijões-encarnados
feijão-galego|feijões-galegos
feijão-preto|feijões-pretos
feijão-verde|feijões-verdes
feijão-vermelho|feijões-vermelhos
feijãozinho|feijõezinhos
felosa-comum|felosas-comuns
fênix|fênixes
ferro-velho|ferros-velhos
ferry|ferries
festival|festivais
feto-águia|fetos-águia
figo-da-índia|figos-da-Índia
figueira-da-índia|figueiras-da-Índia
figueira-de-bengala|figueiras-de-Bengala
figueira-do-diabo|figueiras-do-diabo
figueira-do-inferno|figueiras-do-inferno
figueiral|figueirais
filho-da-puta|filhos-da-puta
filial|filiais
film|filmes
fim-de-semana|fins-de-semana
final|finais
finalzinho|finaizinhos
firewall|firewalls
fita-cola|fitas-cola
fita-crepe|fitas-crepe
fita-do-mar|fitas-do-mar
flex|flexes
flíper|flípers
flor-de-lis|flores-de-lis
floreal|floreais
flush|flushes
foca-elefante|focas-elefante
foca-monge-do-havaí|focas-monge-do-havaí
foca-monge-do-mediterrâneo|focas-monges-do-mediterrâneo
fogal|fogais
fogo-corredor|fogos-corredores
fogo-fátuo|fogos-fátuos
fora-de-jogo|foras-de-jogo
força-tarefa|forças-tarefas
forma-pensamento|formas-pensamento
formiga-argentina|formigas-argentinas
formiga-correição|formigas-correição
formiga-de-fogo|formigas-de-fogo
formiga-lava-pés|formigas-lava-pés
formosa-de-um-dia|formosas-de-um-dia
fôrro|forros
fractal|fractais
frango-d'água|frangos-d'água
frechal|frechais
freezer|freezers
freira-do-alto|freiras-do-alto
freixal|freixais
freixial|freixiais
freixo-do-maná|freixos-do-maná
fricçaõ|fricçoens
frontal|frontais
fruta-de-manteiga|frutas-de-manteiga
fruta-do-conde|frutas-do-conde
fruto-do-conde|frutos-do-conde
fumal|fumais
funçaõ|funçoens
funcçaõ|funcçoens
funchal|funchais
funcionário-fantasma|funcionários-fantasmas
funeral|funerais
fural|furais
fusível|fusíveis
gagauz|gagaúzes
gaial|gaiais
gaita-de-beiços|gaitas-de-beiços
gaita-de-foles|gaitas-de-foles
gaivota-parda|gaivotas-pardas
galinha-d'angola|galinhas-d'angola
galo-silvestre|galos-silvestres
ganha-pão|ganha-pães
ganso-bravo|gansos-bravos
ganso-de-faces-brancas|gansos-de-faces-brancas
ganso-do-canadá|gansos-do-canadá
garça-cinzenta|garças-cizentas
garça-vermelha|garças-vermelhas
garôto|garotos
gata-doméstica|gatas-domésticas
gato-andino|gatos-andinos
gato-bravo|gatos-bravos
gato-bravo-de-patas-negras|gatos-bravos-de-patas-negras
gato-chileno|gatos-chilenos
gato-da-selva|gatos-da-selva
gato-de-algália|gatos-de-algália
gato-de-pallas|gatos-de-pallas
gato-do-deserto|gatos-do-deserto
gato-do-mato|gatos-do-mato
gato-do-mato-grande|gatos-do-mato-grandes
gato-do-mato-pequeno|gatos-do-mato-pequenos
gato-doméstico|gatos-domésticos
gato-dos-pampas|gatos-dos-pampas
gato-dourado-asiático|gatos-dourados-asiáticos
gato-egípcio|gatos-egípcios
gato-esfinge|gatos-esfinge
gato-ferrugem|gatos-ferrugem
gato-leopardo|gatos-leopardos
gato-lobo|gatos-lobos
gato-maracajá|gatos-maracajás
gato-montês|gatos-monteses
gato-mourisco|gatos-mouriscos
gato-palheiro|gatos-palheiros
gato-pescador|gatos-pescadores
gato-pingado|gatos-pingados
gato-sapato|gatos-sapatos
gato-selvagem|gatos-selvagens
gavial|gaviais
gaviaõ|gavioens
gavião-carijó|gaviões-carijó
gavião-de-cauda-curta|gaviões-de-cauda-curta
gavião-de-cauda-vermelha|gaviões-de-cauda-vermelha
gavião-de-rabo-branco|gaviões-de-rabo-branco
gavião-de-sobre-branco|gaviões-de-sobre-branco
gavião-real|gaviões-reais
gazal|gazais
gêlo|gelos
general|generais
genital|genitais
geral|gerais
ghoul|ghouls
giaour|giaours
glória-da-manhã|glórias-da-manhã
glotal|glotais
gol|gols
golfinho-nariz-de-garrafa|golfinhos-nariz-de-garrafa
goma-arábica|gomas-arábicas
goma-laca|gomas-lacas
gorjal|gorjais
gôsto|gostos
govêrno|governos
gôzo|gozos
graal|graais
gradual|graduais
gral|grais
gralha-alpina|gralhas-alpinas
gralha-azul|gralhas-azuis
gralha-cinzenta|gralhas-cinzentas
gralha-de-nuca-cinzenta|gralhas-de-nuca-cinzenta
gralha-preta|gralhas-pretas
gram|grãos
grande-caloria|grandes-calorias
grande-tubarão-branco|grandes-tubarões-brancos
graõ|graons
grão|grãos
grão-de-bico|grãos-de-bico
graxa-de-estudante|graxas-de-estudante
grenal|grenais
grilo-toupeira|grilos-toupeira
grou-azul|grous-azuis
guard-rail|guard-rails
guaxima-do-mangue|guaximas-do-mangue
guincho-comum|guinchos-comuns
hall|halls
hallucinaçaõ|hallucinaçoens
halucinaçaõ|halucinaçoens
hamburger|hamburgers
hammer|hammers
hamster|hamsters
handler|handlers
hash|hashes
hera-terrestre|heras-terrestres
hermão|hermãos
hespanhol|hespanhoes
hexadecimal|hexadecimais
hífen|hífenes
hirax|hiraxes
hírax|híraxes
hirmão|hirmãos
hobby|hobbies
homem-bala|homens-bala
homem-bom|homens-bons
homem-macaco|homens-macacos
homem-rã|homens-rã
homem-sereia|homens-sereias
hortelã-verde|hortelãs-verdes
hortelão|hortelãos
hospital|hospitais
hostel|hostels
husky|huskies
hyrmão|hyrmãos
ideal|ideais
ifrita-de-coroa-azul|ifritas-de-coroa-azul
igual|iguais
íman|ímanes
imóvel|imóveis
imperial|imperiais
impermeável|impermeáveis
impressam|impressões
impressaõ|impressoens
índex|índices
ínio|iníones
instrumental|instrumentais
integral|integrais
interestadual|interestaduais
ipsílon|ipsílones
ípsilon|ípsilones
irmão|irmãos
jabuti-piranga|jabutis-piranga
jabuti-tinga|jabutis-tinga
jacaré-açu|jacarés-açus
jalapa-verdadeira|jalapas-verdadeiras
jambo-rosa|jambos-rosas
jângal|jângales
jardim-de-infância|jardins-de-infância
jasmineiro-branco|jasmineiros-brancos
javali-africano|javalis-africanos
jesus|jesuses
joão-bolão|joões-bolões
joão-de-barro|joões-de-barro
joão-de-bico-pálido|joões-de-bico-pálido
joão-sem-braço|joões-sem-braços
joãozinho|joõezinhos
jogral|jograis
joker|jokers
jornal|jornais
juke-box|juke-boxes
jumper|jumpers
júnior|juniores
junker|junkers
jurdiçam|jurdições
jurdiçaõ|jurdiçoens
jurisdiçam|jurisdições
jurisdiçaõ|jurisdiçoens
jurisdicçam|jurisdicções
jurisdicçaõ|jurisdicçoens
jus|juses
ka-churrasco|kas-churrascos
kaiser|kaisers
kefir|kefirs
kernel|kernels
kettlebell|kettlebells
khmer|khmers
kibbutz|kibbutzim
labial|labiais
lacrimal|lacrimais
ladral|ladrais
ladram|ladroens
ladraõ|ladroens
ladrãozeco|ladrõezecos
lagarta-do-cartucho|lagartas-do-cartucho
lagarto-monitor|lagartos-monitores
lamaçal|lamaçais
lamer|lamers
lammer|lammers
laranja-cravo|laranjas-cravo
laranja-da-china|laranjas-da-china
laranja-da-terra|laranjas-da-terra
laranja-mimosa|laranjas-mimosas
laranjeira-amarga|laranjeiras-amargas
laranjeira-azeda|laranjeiras-azedas
laranjeira-da-terra|laranjeiras-da-terra
laringal|laringais
laringeal|laringeais
laser|lasers
lata-velha|latas-velhas
lateral|laterais
leão-americano|leões-americanos
leão-asiático|leões-asiáticos
leão-baio|leões-baios
leão-da-montanha|leões-da-montanha
leão-de-chácara|leões-de-chácara
leão-do-atlas|leões-do-atlas
leão-do-cabo|leões-do-cabo
leão-marinho|leões-marinhos
leãozão|leõezões
leãozinho|leõezinhos
leilam|leilões
leilaõ|leiloens
lek|lekes
lémur-voador|lémures-voadores
lêmure-voador|lêmures-voadores
lentilha-d'água|lentilhas-d'água
leoa-asiática|leoas-asiáticas
leopardo-das-neves|leopardos-das-neves
lesa-majestade|lesas-majestades
leylam|leylões
leylaõ|leyloens
lince-do-canadá|linces-do-canadá
lince-do-deserto|linces-do-deserto
lince-ibérico|linces-ibéricos
lince-vermelho|linces-vermelhos
lírio-da-paz|lírios-da-paz
lírio-do-amazonas|lírios-do-amazonas
lírio-do-mar|lírios-do-mar
lírio-do-vale|lírios-do-vale
lis|lises
literal|literais
litoral|litorais
livre-arbítrio|livres-arbítrios
livre-pensador|librepensadores
livro-texto|livros-texto
lobby|lobbies
lobo-cerval|lobos-cervais
lobo-cinzento|lobos-cinzentos
lobo-d'alsácia|lobos-d'alsácia
lobo-da-alsácia|lobos-da-alsácia
lobo-da-tasmânia|lobos-da-tasmânia
lobo-da-terra|lobos-da-terra
lobo-gato|lobos-gatos
lobo-ibérico|lobos-ibéricos
lobo-terrível|lobos-terríveis
local|locais
locomotiva-tênder|locomotivas-tênder
locomóvel|locomóveis
lodaçal|lodaçais
lódão|lódãos
loganberry|loganberries
longitudinal|longitudinais
lontra-gigante|lontras-gigantes
lua-de-mel|luas-de-mel
lugar-comum|lugares-comuns
luís|luíses
lula-colossal|lulas-colossais
lula-de-humboldt|lulas-de-humboldt
lula-gigante|lulas-gigantes
lulu-da-pomerânia|lulus-da-pomerânia
má-fé|más-fés
má-formação|más-formações
maçã-de-adão|maçãs-de-Adão
macaco-barrigudo|macacos-barrigudos
macaco-cairara|macacos-cairara
macaco-da-noite|macacos-da-noite
macaco-de-cheiro|macacos-de-cheiro
macaco-guariba|macacos-guariba
macaco-inglês|macacos-ingleses
macaco-japonês|macacos-japoneses
macaco-preto|macacos-pretos
macaco-rhesus|macacos-rhesus
maçapão|maçapães
maçarico-branco|maçaricos-brancos
maçarico-galego|maçaricos-galegos
macuru-de-pescoço-branco|macurus-de-pescoço-branco
madraçal|madraçais
madrigal|madrigais
mãe-de-santo|mães-de-santo
mãe-velha|mães-velhas
magistral|magistrais
mainá-indiano|mainás-indianos
maís|maíses
majlis|majlises
mal|males
malamute-do-alasca|malamutes-do-alasca
malícia-de-mulher|maliícias-de-mulher
malva-bastarda|malvas-bastardas
malva-branca|malvas-brancas
malva-comum|malvas-comuns
malva-rosa|malvas-rosas
manancial|mananciais
mandioca-brava|mandiocas-bravas
mandiocal|mandiocais
mangal|mangais
mangual|manguais
mangue-preto|mangues-pretos
mangueiral|mangueirais
manguezal|manguezais
manual|manuais
maõ|maons
mão|mãos
mão-cheia|mãos-cheias
mão-de-obra|mãos-de-obra
mão-pelada|mãos-peladas
mapa-múndi|mapas-múndi
máquina-de-escrever|máquinas-de-escrever
máquina-ferramenta|máquinas-ferramentas
marechal|marechais
margarida-amarela|margaridas-amarelas
marginal|marginais
maria-chiquinha|marias-chiquinhas
maria-farinha|marias-farinha
maria-mole|marias-moles
maria-rapaz|marias-rapazes
marimbondo-chapéu|marimbondos-chapéu
marmeleira-da-índia|marmeleiras-da-índia
marmeleiro-da-índia|marmeleiros-da-índia
marsupial|marsupiais
marta-europeia|martas-europeias
marta-européia|martas-européias
martim-pescador|martins-pescadores
matagal|matagais
matéria-prima|matérias-primas
material|materiais
maternal|maternais
mau-olhado|maus-olhados
médica-legista|médicas-legistas
médico-legista|médicos-legistas
megaohm|megaohms
megapascal|megapascais
megapixel|megapixels
megapíxel|megapíxeis
meia-calça|meias-calças
meia-de-leite|meias-de-leite
meia-dúzia|meias-dúzias
meia-encadernação|meias-encadernações
meia-entrada|meias-entradas
meia-final|meias-finais
meia-idade|meias-idades
meia-irmã|meias-irmãs
meia-lua|meias-luas
meia-luz|meias-luzes
meia-noite|meias-noites
meia-risca|meias-riscas
meia-vida|meias-vidas
meia-volta|meias-voltas
meio-dia|meios-dias
meio-fio|meios-fios
meio-irmão|meios-irmãos
meio-sangue|meios-sangues
meio-tempo|meios-tempos
meio-termo|meios-termos
meio-tio|meios-tios
meio-tom|meios-tons
melancia-da-praia|melancias-da-praia
melão-de-são-caetano|melões-de-são-caetano
melro-aquático|melros-aquáticos
melro-d'água|melros-d'água
melro-peixeiro|melros-peixeiros
menina-mulher|meninas-mulheres
mermão|mermãos
mes|meses
mès|meses
mesa-de-cabeceira|mesas-de-cabeceira
mescal|mescais
mesinha-de-cabeceira|mesinhas-de-cabeceira
mesteiral|mesteirais
mestre-de-cerimónias|mestres-de-cerimónias
metacarpal|metacarpais
metal|metais
metical|meticais
metrossexual|metrossexuais
milharal|milharais
milho-miúdo|milhos-miúdos
mimo-de-vênus|mimos-de-vênus
mineral|minerais
mirror|mirrors
mise-en-scène|mises-en-scène
miseravel|miseraveis
missal|missais
míssel|mísseis
misto-quente|mistos-quentes
mm|mms
mobelha-grande|mobelhas-grandes
mocho-d'orelhas|mochos-d'orelhas
mocho-de-orelhas|mochos-de-orelhas
mocho-galego|mochos-galegos
mocho-pequeno|mochos-pequenos
moçx|moçxs
modal|modais
modêlo|modelos
môfo|mofos
monçam|monções
monçaõ|monçoens
monocristal|monocristais
montanha-russa|montanhas-russas
moral|morais
morcego-vampiro|morcegos-vampiros
morta-viva|mortas-vivas
môrto|mortos
morto-vivo|mortos-vivos
mosca-das-frutas|moscas-das-frutas
mosca-de-banheiro|moscas-de-banheiro
mosca-de-estábulo|moscas-de-estábulo
mosca-varejeira|moscas-varejeiras
mosquito-da-dengue|mosquitos-da-dengue
mostardal|mostardais
moto-quatro|motos-quatro
mouçam|mouções
mouçaõ|mouçoens
móvel|móveis
msol|msols
mucual|mucuais
mulher-dama|mulheres-damas
mulher-homem|mulheres-homens
mulher-macho|mulheres-machos
multinacional|multinacionais
mundial|mundiais
mural|murais
murtal|murtais
musical|musicais
nabal|nabais
nadador-salvador|nadadores-salvadores
náilon|náilones
namôro|namoros
não|nãos
napalm|napalms
naperon|naperones
narciso-das-areias|narcisos-das-areias
nariz-de-cera|narizes-de-cera
narval|narvais
nasal|nasais
natureza-morta|naturezas-mortas
navio-almirante|navios-almirantes
navio-farol|navios-faróis
navio-tanque|navios-tanque
negus|neguses
nhá-benta|nhás-bentas
nickel|nickeis
ninhal|ninhais
níquel|níqueis
nível|níveis
nogueira-pecã|nogueiras-pecã
nogueiral|nogueirais
noitibó-cinzento|noitibós-cinzentos
noitibó-da-europa|noitibós-da-europa
novo-rico|novos-ricos
noz-macadâmia|nozes-macadâmia
noz-moscada|nozes-moscadas
numeral|numerais
obus|obuses
occipital|occipitais
ohm|ohms
ôlho|olhos
olho-d'água|olhos-d'água
olival|olivais
oliveiral|oliveirais
onça-d'água|onças-d'água
onça-parda|onças-pardas
onça-pintada|onças-pintadas
oral|orais
orégão|orégãos
orelha-de-judas|orelhas-de-judas
órfão|órfãos
organizaçaõ|organizaçoens
órgão|órgãos
original|originais
ourégão|ourégãos
ouriço-cacheiro|ouriços-cacheiros
ouriço-do-mar|ouriços-do-mar
outdoor|outdoors
outlier|outliers
p.|pp.
pág.|págs.
pagão|pagãos
pager|pagers
pai-de-santo|pais-de-santo
país|países
palatal|palatais
palavra-ônibus|palavras-ônibus
palavra-valise|palavras-valise
panda-gigante|pandas-gigantes
panda-vermelho|pandas-vermelhos
pantanal|pantanais
pantera-nebulosa|panteras-nebulosas
pantera-negra|panteras-negras
pão|pães
pão-de-galinha|pães-de-galinha
pão-de-galo|pães-de-galo
pão-de-leite|pães-de-leite
pão-de-ló|pães-de-ló
pão-de-passarinho|pães-de-passarinhos
pão-de-pássaros|pães-de-pássaros
pão-de-pobre|pães-de-pobre
pão-duro|pães-duros
pão-por-deus|pães-por-Deus
pãozinho|pãezinhos
papagaio-do-mar|papagaios-do-mar
papagaio-do-mar-do-atlântico|papagaios-do-mar-do-atlântico
papamóvel|papamóveis
paparazzo|paparazzi
papel-carbono|papéis-carbono
papel-cartão|papéis-cartão
papel-manteiga|papéis-manteiga
papel-moeda|papéis-moeda
papel-toalha|papéis-toalha
papelzinho|papeizinhos
papo-furado|papos-furados
papo-seco|papos-secos
pára-sol|pára-sois
pardal|pardais
pardal-doméstico|pardais-domésticos
parietal|parietais
parmesão|parmesãos
parser|parsers
pascal|pascais
pascoal|pascoais
pastel-dos-tintureiros|pastéis-dos-tintureiros
pastor-alemão|pastores-alemães
pastora-alemã|pastoras-alemãs
pastoral|pastorais
pato-do-mato|patos-do-mato
pato-marreco|patos-marrecos
pato-mudo|patos-mudos
pato-real|patos-reais
pato-selvagem|patos-selvagens
pato-vapor|patos-vapor
patriarcal|patriarcais
pau-d'áquila|paus-d'áquila
pau-d'arco|paus-d'arco
pau-de-águia|paus-de-águia
pau-de-águila|paus-de-águila
pau-de-arara|paus-de-arara
pau-furado|paus-furados
pau-mandado|paus-mandados
pau-preto|paus-pretos
pau-rosa|paus-rosa
pavão-real|pavões-reais
pays|payses
paywall|paywalls
pé-de-altar|pés-de-altar
pé-de-atleta|pés-de-atleta
pé-de-boi|pés-de-boi
pé-de-cabra|pés-de-cabra
pé-de-cana|pés-de-cana
pé-de-chumbo|pés-de-chumbo
pé-de-galinha|pés-de-galinha
pé-de-gato|pés-de-gato
pé-de-meia|pés-de-meia
pé-de-moça|pés-de-moça
pé-de-moleque|pés-de-moleque
pé-de-pato|pés-de-pato
pé-direito|pés-direitos
pé-grande|pés-grandes
pé-no-saco|pés-no-saco
pé-rachado|pés-rachados
pé-rapado|pés-rapados
pé-vela|pés-velas
pedal|pedais
peddy-paper|peddy-papers
pedestal|pedestais
pedra-da-lua|pedras-da-lua
pedra-pomes|pedras-pomes
pedregal|pedregais
pega-azul|pegas-azuis
pega-rabuda|pegas-rabudas
peixe-aranha|peixes-aranha
peixe-arqueiro|peixes-arqueiros
peixe-beta|peixes-beta
peixe-de-briga|peixes-de-briga
peixe-de-são-pedro|peixes-de-são-pedro
peixe-diabo|peixes-diabos
peixe-dourado|peixes-dourados
peixe-eléctrico|peixes-eléctricos
peixe-elétrico|peixes-elétricos
peixe-espada|peixes-espada
peixe-espada-preto|peixes-espada-pretos
peixe-espátula|peixes-espátula
peixe-frade|peixes-frade
peixe-gato|peixes-gato
peixe-lapa|peixes-lapa
peixe-lua|peixes-lua
peixe-papagaio|peixes-papagaio
peixe-pescador|peixes-pescadores
peixe-sapo|peixes-sapo
peixe-vermelho|peixes-vermelhos
peixe-voador|peixes-voadores
peixe-zebra|peixes-zebra
peixinho-da-horta|peixinhos-da-horta
penal|penais
peneireiro-vulgar|peneireiros-vulgares
pente-de-macaco|pentes-de-macaco
penny|pennies
pepino-do-mar|pepinos-do-mar
péra|peras
pêra|peras
pera-de-advogado|peras-de-advogado
pera-maçã|peras-maçã
peral|perais
perca-amarela|percas-amarelas
percentual|percentuais
perdam|perdoens
perdaõ|perdoens
perdiz-cinzenta|perdizes-cinzentas
peregrinaçam|peregrinações
peregrinaçaõ|peregrinaçoens
perereca-de-banheiro|pererecas-de-banheiro
periquito-australiano|periquitos-australianos
perna-de-pau|pernas-de-pau
pêro|peros
pêso|pesos
pêssego-careca|pêssegos-carecas
pharol|pharoes
pica-pau-malhado-grande|pica-paus-malhados-grandes
pica-pau-malhado-pequeno|pica-paus-malhados-pequenos
pimenta-branca|pimentas-brancas
pimenta-caiena|pimentas-caiena
pimenta-de-caiena|pimentas-de-caiena
pimenta-do-reino|pimentas-do-reino
pimenta-negra|pimentas-negras
pimenta-preta|pimentas-pretas
pimenta-redonda|pimentas-redondas
pinball|pinballs
pinguim-adélia|pinguins-adélia
pinguim-de-adélia|pinguins-de-adélia
pinguim-de-magalhães|pinguins-de-Magalhães
pinguim-gentoo|pinguins-gentoo
pinguim-imperador|pinguins-imperadores
pinguim-rei|pinguins-rei
pinhal|pinhais
pinheiral|pinheirais
pinheiro-carrasco|pinheiros-carrascos
pinheiro-do-paraná|pinheiros-do-paraná
pinscher|pinschers
pinta-cega|pintas-cegas
piolho-da-cabeça|piolhos-da-cabeça
piolho-de-cabeça|piolhos-de-cabeça
piolho-de-cobra|piolhos-de-cobra
piolho-de-urubu|piolhos-de-urubu
piranha-vermelha|piranhas-vermelha
pisco-de-peito-azul|piscos-de-peito-azul
pisco-de-peito-ruivo|piscos-de-peito-ruivo
pita-cega|pitas-cegas
piteira-do-caribe|piteiras-do-caribe
píton|pitons
pixel|pixels
píxel|píxeis
placa-mãe|placas-mãe
planeta-anão|planetas-anões
plátano-americano|plátanos-americanos
player|players
plural|plurais
pobre-diabo|pobres-diabos
poial|poiais
pointer|pointers
pombal|pombais
pombo-bravo|pombos-bravos
pombo-comum|pombos-comuns
pombo-correio|pombos-correio
pombo-das-rochas|pombos-das-rochas
pombo-doméstico|pombos-domésticos
pombo-passageiro|pombos-passageiros
pombo-torcaz|pombos-torcazes
pomo-de-adão|pomos-de-Adão
poquémon|poquémones
pôr-do-sol|pores-do-sol
porca-sara|porcas-saras
porcentual|porcentuais
porco-da-terra|porcos-da-terra
porco-espim|porcos-espim
porco-formigueiro|porcos-formigueiros
porquinho-da-índia|porquinhos-da-índia
portal|portais
pôrto|portos
pós-natal|pós-natais
poser|posers
postal|postais
potencial|potenciais
pouco-caso|poucos-casos
preá-da-índia|preás-da-índia
precisaõ|precisoens
preto-velho|pretos-velhos
pretzel|pretzels
primeira-dama|primeiras-damas
primeira-ministra|primeiras-ministras
primeiro-cavalheiro|primeiros-cavalheiros
primeiro-de-abril|primeiros-de-abril
primeiro-ministro|primeiros-ministros
primeiro-tenente|primeiros-tenentes
principal|principais
príncipe-eleitor|príncipes-eleitores
prisam|prisões
prisaõ|prisões
projectil|projecteis
proxy|proxies
pseudocereal|pseudocereais
púgil|pugís
pul|pules
pull|pulls
punch|punches
punhal|punhais
puro-sangue|puros-sangues
pus|puses
putsch|putsches
quadraçal|quadraçais
quadrisal|quadrisais
quadro-negro|quadros-negros
quantum|quanta
quarta-feira|quartas-feiras
quartel-general|quartéis-generais
quartel-mestre|quartéis-mestres
quati-de-nariz-branco|quatis-de-nariz-branco
queda-d'água|quedas-d'água
queijo-de-coalho|queijos-de-coalho
queixal|queixais
quengaral|quengarais
questam|questoens
questaõ|questoens
quilowatt-hora|quilowatts-hora
quinta-feira|quintas-feiras
quintal|quintais
rã-assobiadora|rãs-assobiadoras
rã-touro|rãs-touro
rabaça|rabaçal
rabirruivo-de-testa-branca|rabirruivos-de-testa-branca
rabo-de-cavalo|rabos-de-cavalo
rabo-de-saia|rabos-de-saia
radical|radicais
raio-x|raios-X
raís|raíses
raiz|raízes
raiz-forte|raízes-fortes
ramal|ramais
raposa-cinzenta|raposas-cinzentas
raposa-do-ártico|raposas-do-ártico
raposa-do-cabo|raposas-do-cabo
raposa-vermelha|raposas-vermelhas
rappel|rappels
rasaõ|rasoens
rastel|rastels
ratão-d'água|ratões-d'água
ratão-do-banhado|ratões-do-banhado
rato-almiscareiro|ratos-almiscareiros
rato-chino|ratos-chinos
rato-do-campo|ratos-do-campo
razaõ|razoens
real|reais
reality|realities
recall|recalls
recital|recitais
récor|récors
ref.|refs.
referencial|referenciais
refill|refills
refrêsco|refrescos
rêgo|regos
régua-tê|réguas-tê
remember|remembers
remix|remixes
repolho-gambá|repolhos-gambá
resaõ|resoens
rezaõ|rezoens
rial|riais
rico-homem|ricos-homens
rímel|rímeis
rinoceronte-negro|rinocerontes-negros
risca-de-giz|riscas-de-giz
ritual|rituais
roca-da-velha|rocas-da-velha
roda-gigante|rodas-gigantes
roda-viva|rodas-vivas
rola-turca|rolas-turcas
roller|rollers
romão|romãos
rorqual|rorquais
rosa-canina|rosas-caninas
rosa-da-china|rosas-da-china
rosa-de-cão|rosas-de-cão
rosa-do-bem-fazer|rosas-do-bem-fazer
rosa-dos-ventos|rosas-dos-ventos
roseiral|roseirais
rotacional|rotacionais
router|routers
royalty|royalties
ruiva-dos-tintureiros|ruivas-dos-tintureiros
sabiá-una|sabiás-unas
sabotador|sabotadora
sabugal|sabugais
saco-de-gambá|sacos-de-gambá
sal|sais
salgueiro-chorão|salgueiros-chorões
salmão-atlântico|salmões-atlânticos
salto-alto|saltos-altos
salvaçam|salvações
salvaçaõ|salvaçoens
salvo-conduto|salvos-condutos
sangue-frio|sangues-frios
sanguinária-do-canadá|sanguinárias-do-canadá
santa-luzia|santas-luzias
santol|santols
são|sãos
sapatinho-de-judeu|sapatinhos-de-judeu
sapatinho-do-diabo|sapatinhos-do-diabo
sapinho-admirável-de-barriga-vermelha|sapinhos-admiráveis-de-barriga-vermelha
sapo-cururu|sapos-cururus
sapo-do-mar|sapos-do-mar
sargento-chefe|sargentos-chefes
sarrafaçal|sarrafaçais
sável|sáveis
scaner|scaners
scanner|scanners
schnitzel|schnitzels
séc.|sécs.
secretário-geral|secretários-gerais
segrêdo|segredos
segunda-dama|segundas-damas
segunda-feira|segundas-feiras
segundo-cavalheiro|segundos-cavalheiros
seleçaõ|seleçoens
selecçaõ|selecçoens
sêlo|selos
sémen|sémenes
semi-deus|semi-deuses
semi-final|semi-finaes
semideus|semideuses
semifinal|semifinais
semimetal|semimetais
semivogal|semivogais
senhorx|senhorxs
sénior|seniores
sênior|seniores
serval|servais
server|servers
sexta-feira|sextas-feiras
sgraffito|sgraffiti
shekel|shekels
sidearm|sidearms
signo-de-salomão|signos-de-salomão
sinal|sinais
situação-problema|situações-problema
sketch|sketches
skill|skills
smash|smashes
sniper|snipers
snorkel|snorkels
sobral|sobrais
sobrinha-neta|sobrinhas-netas
sobrinho-neto|sobrinhos-netos
social|sociais
soco-inglês|socos-ingleses
sol-pôr|sol-pores
sôldo|soldos
solução-tampão|soluções-tampão
sommelier|sommeliers
sopinha-de-massa|sopinhas-de-massa
sôpro|sopros
sótão|sótãos
souvenir|souvenirs
spaniel|spaniels
spoiler|spoilers
sr.e|Sres.
sre.|Sres.
staccato|staccati
stress|stresses
strudel|strudels
subnível|subníveis
suboficial|suboficiais
substancial|substanciais
subtotal|subtotais
subwoofer|subwoofers
sucursal|sucursais
sulfossal|sulfossais
superior-geral|superiores-gerais
suprarrenal|suprarrenais
surda-muda|surdas-mudas
surdo-mudo|surdos-mudos
sursis|sursises
surucuá-de-barriga-amarela|surucuás-de-barriga-amarela
surucuá-de-barriga-dourada|surucuás-de-barriga-dourada
surucuá-grande-de-barriga-amarela|surucuás-grandes-de-barriga-amarela
swell|swells
tabela-verdade|tabelas-verdade
tabelião|tabeliães
tamanduá-bandeira|tamanduás-bandeira
tamanduá-mirim|tamanduás-mirins
tamis|tamises
tandoor|tandoors
taquaral|taquarais
tarambola-dourada|tarambolas-douradas
tartaruga-cabeçuda|tartarugas-cabeçudas
tartaruga-da-amazónia|tartarugas-da-amazónia
tartaruga-da-amazônia|tartarugas-da-amazônia
tartaruga-de-couro|tartarugas-de-couro
tartaruga-de-galápagos|tartarugas-de-galápagos
tartaruga-de-pente|tartarugas-de-pente
tartaruga-do-amazonas|tartarugas-do-amazonas
tartaruga-do-mar|tartarugas-do-mar
tartaruga-marinha|tartarugas-marinhas
tartaruga-matamatá|tartarugas-matamatá
tartaruga-mordedora|tartarugas-mordedoras
tartaruga-oliva|tartarugas-oliva
tartaruga-verde|tartarugas-verdes
tatu-de-folha|tatus-de-folhas
tatu-de-jardim|tatus-de-jardim
tatu-galinha|tatus-galinha
tatu-veado|tatus-veado
tatu-verdadeiro|tatus-verdadeiros
tatuzinho-de-jardim|tatuzinhos-de-jardim
táxi-lotação|táxis-lotação
tchão|tchãos
teaser|teasers
teiú-argentino|teiús-argentinos
teiú-gigante|teiús-gigantes
teiú-mascarado|teiús-mascarados
telejornal|telejornais
telemóvel|telemóveis
tempêro|temperos
temporal|temporais
tendal|tendais
tenente-coronel|tenentes-coronéis
tenente-general|tenentes-generais
tentilhão-montês|tentilhões-monteses
terça-feira|terças-feiras
terceiro-sargento|terceiros-sargentos
terminal|terminais
tetraz-grande-das-serras|tetrazes-grandes-das-serras
texugo-americano|texugos-americanos
texugo-do-mel|texugos-do-mel
thorax|thoraxes
thriller|thrillers
thumbnail|thumbnails
tia-avó|tias-avós
tigre-da-tasmânia|tigres-da-tasmânia
tigre-de-bengala|tigres-de-bengala
tigre-de-sumatra|tigres-de-sumatra
tigre-dente-de-sabre|tigres-dente-de-sabre
tigre-siberiano|tigres-siberianos
timer|timers
tio-avô|tios-avôs
tôco|tocos
tomate-arbóreo|tomates-arbóreos
tomate-de-árvore|tomates-de-árvore
tomate-de-sodoma|tomates-de-sodoma
tomate-inglês|tomates-ingleses
tomateiro-do-diabo|tomateiros-do-diabo
tonalito-trondhjemito-granodiorito|tonalitos-trondhjemito-granodioritos
toner|toners
tôner|tôners
toolbox|toolboxes
torda-mergulheira|tordas-mergulheiras
tordo-comum|tordos-comuns
tôrno|tornos
torr|torrs
tosta-mista|tostas-mistas
total|totais
toupeira-d'água|toupeiras-d'água
toupeira-de-água|toupeiras-de-água
tour|tours
toural|tourais
traça-de-livros|traças-de-livros
traça-dos-livros|traças-dos-livros
traduçaõ|traduçoens
traduçãozinha|traduçõezinhas
traducçaõ|traducçoens
traiçaõ|traiçoens
trailer|trailers
transbôrdo|transbordo
transponder|transponders
transtôrno|transtornos
transversal|transversais
trem-bala|trens-bala
tremedal|tremedais
trevo-azedo|trevos-azedos
tribunal|tribunais
trienal|trienais
trigal|trigais
trisal|trisais
trivial|triviais
trôco|trocos
trôço|troços
troll|trolls
tromba-d'água|trombas-d'água
trombeta-chinesa|trombetas-chinesas
tropêço|tropeços
trovaõ|trovoens
try|tries
tubarão-baleia|tubarões-baleia
tubarão-branco|tubarões-brancos
tubarão-da-groenlândia|tubarões-da-groenlândia
tubarão-frade|tubarões-frade
tubarão-golfinho|tubarões-golfinho
tubarão-peregrino|tubarões-peregrinos
tubarão-tigre|tubarões-tigre
tubarão-vitamínico|tubarões-vitamínicos
tucano-de-bico-preto|tucanos-de-bico-preto
tumbérgia-azul|tumbérgias-azuis
túnel|túneis
tutorial|tutoriais
umbral|umbrais
unha-de-asno|unhas-de-asno
unha-de-cavalo|unhas-de-cavalo
unha-de-gato|unhas-de-gato
urso-branco|ursos-brancos
urso-cinzento|ursos-cinzentos
urso-de-kodiak|ursos-de-kodiak
urso-do-atlas|ursos-do-atlas
urso-malaio|ursos-malaios
urso-negro|ursos-negros
urso-pardo|ursos-pardos
urso-polar|ursos-polares
urubu-caçador|urubus-caçadores
urubu-da-mata|urubus-da-mata
urubu-de-cabeça-amarela|urubus-de-cabeça-amarela
urubu-de-cabeça-preta|urubus-de-cabeça-preta
urubu-de-cabeça-vermelha|urubus-de-cabeça-vermelha
urubu-preto|urubus-pretos
urubu-rei|urubus-reis
urzal|urzais
uva-de-cão|uvas-de-cão
uva-de-galo|uvas-de-galo
uva-de-gato|uvas-de-gato
uva-do-japão|uvas-do-japão
uva-espim|uvas-espim
uva-passa|uvas-passas
vaca-loura|vacas-louras
val|vales
valor-verdade|valores-verdade
vão|vãos
vaquita-marinha|vaquitas-marinhas
vara-de-ouro|varas-de-ouro
varal|varais
variável|variáveis
vastidaõ|vastidoens
vazaõ|vazoens
veado-campeiro|veados-campeiros
veado-de-cauda-branca|veados-de-cauda-branca
veado-do-cabo|veados-do-cabo
vegetal|vegetais
véi|véios
vela-hora|velas-hora
velour|velours
vendaval|vendavais
veraõ|veroens
verde-folha|verdes-folha
verde-limão|verdes-limão
verde-maçã|verdes-maçã
verde-menta|verdes-menta
vespa-do-mar|vespas-do-mar
via-crúcis|vias-crúcis
via-sacra|vias-sacras
víbora-do-gabão|víboras-do-gabão
vide-da-índia|vides-da-índia
vide-da-judeia|vides-da-judeia
vidral|vidrais
vigário-geral|vigários-gerais
vinca-de-madagáscar|vincas-de-madagáscar
vinha-d'alho|vinhas-d'alho
vinha-d'alhos|vinhas-d'alhos
vinha-da-judeia|vinhas-da-judeia
vinhadalhos|vinhasdalhos
violaçaõ|violaçoens
violeta-africana|violetas-africanas
virginal|virginais
visão-americano|visões-americanos
visom-americano|visons-americanos
vison-americano|visons-americanos
visual|visuais
vitória-régia|vitórias-régias
vitral|vitrais
viúva-negra|viúvas-negras
vogal|vogais
voucher|vouchers
voxel|voxels
vulcaõ|vulcões
vulcão-escudo|vulcões-escudo
wafer|wafers
wallaby|wallabies
webcam|webcams
weber|webers
whisky|whiskies
worm|worms
xor|xors
yrmão|yrmãos
zagal|zagais
zambujal|zambujais
zângão|zângãos
zêlo|zelos
zoom|zooms
`;

const GENDER_NAMES: Record<string, GrammaticalGender> = {
  m: "masculine",
  f: "feminine",
  n: "neuter",
};

/** Nouns whose gender contradicts what their ending suggests. */
export const GENDERS: ReadonlyMap<string, GrammaticalGender> = new Map(
  GENDER_DATA.split("\n")
    .filter((line) => line.length > 0)
    .map((line) => {
      const [lemma, gender] = line.split("|") as [string, string];
      return [lemma, GENDER_NAMES[gender] ?? "masculine"] as const;
    }),
);

/** Nouns whose plural the rules do not produce. */
export const PLURALS: ReadonlyMap<string, string> = new Map(
  PLURAL_DATA.split("\n")
    .filter((line) => line.length > 0)
    .map((line) => line.split("|") as [string, string]),
);
